<template>
  <div>
    <h3
      v-if="
        playerPlayMakerGpsData.length > 0 ||
        checkIfPlayerHasGamesCatapultGPSData
      "
    >
      GPS reports
    </h3>

    <div
      v-if="checkIfPlayerHasGamesCatapultGPSData"
      class="player-individual-reports all-training-reports"
    >
      <a
        href="javascript:;"
        class="view-all-reports"
        @click="openGameGPSModal('catapult')"
      >
        <img class="large-icon-shape" src="./img/gps-image.svg" alt="" />
        <span>View all game <br />GPS Catapult reports</span>
      </a>

      <a
        v-if="checkIfPlayerHasTrainingCatapultGPSData"
        href="javascript:;"
        class="view-all-reports"
        @click="openTrainingGPSModal('catapult')"
      >
        <img class="large-icon-shape" src="./img/gps-image.svg" alt="" />
        <span>View all training <br />GPS Catapult reports</span>
      </a>
    </div>

    <div
      v-if="playerPlayMakerGpsData.length > 0"
      class="player-individual-reports all-training-reports"
    >
      <a
        href="javascript:;"
        class="view-all-reports"
        @click="openGameGPSModal('playMaker')"
      >
        <img class="large-icon-shape" src="./img/gps-image.svg" alt="" />
        <span>View all game GPS <br />PlayMaker reports</span>
      </a>

      <a
        v-if="playerPlayMakerGpsData.length > 0"
        href="javascript:;"
        class="view-all-reports"
        @click="openTrainingGPSModal('playMaker')"
      >
        <img class="large-icon-shape" src="./img/gps-image.svg" alt="" />
        <span>View all training GPS <br />PlayMaker reports</span>
      </a>
    </div>
  </div>

  <!-- Catapult Game Modal -->
  <GPSModal
    v-if="showCatapultGameGPSModal"
    :showModal="showCatapultGameGPSModal"
    @update:showModal="showCatapultGameGPSModal = $event"
    @update:activeTab="activeGPSTab = $event"
    size="xl"
    :modalTitle="'Seasons GPS Catapult Game Reports'"
    :activeTab="activeGPSTab"
  >
    <template #overview>
      <div class="tab-panel overview-panel">
        <div class="catapult-tabs">
          <button
            :class="{ active: catapultSeasonTab === 'current' }"
            @click="changeCatapultSeasonTab('current', 'game')"
          >
            This Season
          </button>
          <button
            :class="{ active: catapultSeasonTab === 'last' }"
            @click="changeCatapultSeasonTab('last', 'game')"
          >
            Last Season
          </button>
        </div>
        <div v-if="catapultSeasonTab === 'current'">
          <div class="overview-grid">
            <div class="radar-section">
              <RadarPerformanceChart
                :gps-data="lastGameSessionData"
                :personal-best="
                  currentPersonalBestAndAveragesCatapultData.games &&
                  currentPersonalBestAndAveragesCatapultData.games.pb
                "
                :season-average="
                  currentPersonalBestAndAveragesCatapultData.games
                "
                :last-session="lastGameSessionData"
                :gps-type="gpsType"
              />
            </div>
            <div class="metrics-summary">
              <h4>Performance Summary</h4>
              <div class="summary-grid">
                <div class="summary-card distance">
                  <div class="card-icon">🏃</div>
                  <div class="card-content">
                    <h5>Total Distance</h5>
                    <p class="value">
                      {{ getFormattedValue("distance", "lastGameSessionData") }}
                    </p>
                    <span
                      class="trend"
                      :class="getTrendClass('distance', 'lastGameSessionData')"
                    >
                      {{
                        getTrendPercentage("distance", "lastGameSessionData")
                      }}
                    </span>
                  </div>
                </div>
                <div class="summary-card speed">
                  <div class="card-icon">⚡</div>
                  <div class="card-content">
                    <h5>Top Speed</h5>
                    <p class="value">
                      {{ getFormattedValue("speed", "lastGameSessionData") }}
                    </p>
                    <span
                      class="trend"
                      :class="getTrendClass('speed', 'lastGameSessionData')"
                    >
                      {{ getTrendPercentage("speed", "lastGameSessionData") }}
                    </span>
                  </div>
                </div>
                <div class="summary-card intensity">
                  <div class="card-icon">🔥</div>
                  <div class="card-content">
                    <h5>Intensity</h5>
                    <p class="value">
                      {{
                        getFormattedValue("intensity", "lastGameSessionData")
                      }}
                    </p>
                    <span
                      class="trend"
                      :class="getTrendClass('intensity', 'lastGameSessionData')"
                    >
                      {{
                        getTrendPercentage("intensity", "lastGameSessionData")
                      }}
                    </span>
                  </div>
                </div>
                <div class="summary-card hsr">
                  <div class="card-icon">💨</div>
                  <div class="card-content">
                    <h5>High Speed Running</h5>
                    <p class="value">
                      {{ getFormattedValue("hsr", "lastGameSessionData") }}
                    </p>
                    <span
                      class="trend"
                      :class="getTrendClass('hsr', 'lastGameSessionData')"
                    >
                      {{ getTrendPercentage("hsr", "lastGameSessionData") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="catapultSeasonTab === 'last'">
          <div class="overview-grid">
            <div class="radar-section">
              <RadarPerformanceChart
                :gps-data="lastSeasonGameSessionData"
                :personal-best="
                  lastSeasonPersonalBestAndAveragesCatapultData.games &&
                  lastSeasonPersonalBestAndAveragesCatapultData.games.pb
                "
                :season-average="
                  lastSeasonPersonalBestAndAveragesCatapultData.games
                "
                :last-session="lastSeasonGameSessionData"
                :gps-type="gpsType"
              />
            </div>
            <div class="metrics-summary">
              <h4>Performance Summary (Last Season)</h4>
              <div class="summary-grid">
                <div class="summary-card distance">
                  <div class="card-icon">🏃</div>
                  <div class="card-content">
                    <h5>Total Distance</h5>
                    <p class="value">
                      {{
                        getFormattedValue(
                          "distance",
                          "lastSeasonGameSessionData",
                        )
                      }}
                    </p>
                  </div>
                </div>
                <div class="summary-card speed">
                  <div class="card-icon">⚡</div>
                  <div class="card-content">
                    <h5>Top Speed</h5>
                    <p class="value">
                      {{
                        getFormattedValue("speed", "lastSeasonGameSessionData")
                      }}
                    </p>
                  </div>
                </div>
                <div class="summary-card intensity">
                  <div class="card-icon">🔥</div>
                  <div class="card-content">
                    <h5>Intensity</h5>
                    <p class="value">
                      {{
                        getFormattedValue(
                          "intensity",
                          "lastSeasonGameSessionData",
                        )
                      }}
                    </p>
                  </div>
                </div>
                <div class="summary-card hsr">
                  <div class="card-icon">💨</div>
                  <div class="card-content">
                    <h5>High Speed Running</h5>
                    <p class="value">
                      {{
                        getFormattedValue("hsr", "lastSeasonGameSessionData")
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #detailed>
      <div class="tab-panel detailed-panel">
        <div
          class="gps-section catapult-section"
          v-if="playerDailyMins && playerDailyMins.length > 0"
        >
          <div class="section-header">
            <h3>Catapult GPS Performance Data</h3>
            <p class="section-description">
              Physical performance metrics from GPS tracking
            </p>
          </div>
          <b-form-select class="mb-3" v-model="catapultGameTab">
            <b-form-select-option :value="null">
              Please select an option
            </b-form-select-option>
            <b-form-select-option value="catapult-game-distance-tab">
              Total Distance
            </b-form-select-option>
            <b-form-select-option value="catapult-game-hsr-tab">
              High Speed Running
            </b-form-select-option>
            <b-form-select-option value="catapult-game-accelerations-tab">
              Accelerations / Decelerations
            </b-form-select-option>
            <b-form-select-option value="catapult-game-intensity-tab">
              Intensity
            </b-form-select-option>
            <b-form-select-option value="catapult-game-perTopSpeed-tab">
              % Top Speed
            </b-form-select-option>
            <b-form-select-option value="catapult-game-topSpeed-tab">
              Top Speed
            </b-form-select-option>
          </b-form-select>
          <div class="tabs-wrapper">
            <div
              class="tab-content"
              v-if="catapultGameTab === 'catapult-game-distance-tab'"
            >
              <div class="metrics-wrapper">
                <h4>
                  Total distance
                  <span class="small-select">
                    <b-form-select class="mb-3" v-model="unitValue">
                      <b-form-select-option value="Meters"
                        >Meters</b-form-select-option
                      >
                      <b-form-select-option value="Miles"
                        >Miles</b-form-select-option
                      >
                      <b-form-select-option value="Km">Km</b-form-select-option>
                    </b-form-select>
                  </span>
                </h4>

                <div class="metrics-item">
                  <p class="title">Game Avg</p>
                  <p class="value">
                    {{
                      roundedGameAvgDistance(
                        playerPersonalBestAndAverages.games.session_distance,
                      )
                    }}
                    <span class="very-large">{{
                      unitLabelMilesKMmeters()
                    }}</span>
                  </p>
                  <div
                    class="gauge-wrapper game-avg-cat"
                    :class="
                      getGaugeValue(
                        'game-avg-cat',
                        Math.round(
                          playerPersonalBestAndAverages.games.session_distance,
                        ),
                      )
                    "
                  >
                    <div class="gauge">
                      <p>
                        {{
                          getGaugeValue(
                            "game-avg-cat",
                            Math.round(
                              playerPersonalBestAndAverages.games
                                .session_distance,
                            ),
                            "notCss",
                          )
                        }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="metrics-item">
                  <p class="title">Game PB</p>
                  <p class="value">
                    {{
                      roundedGameAvgDistance(
                        playerPersonalBestAndAverages.games.pb.session_distance,
                      )
                    }}
                    <span class="very-large">{{
                      unitLabelMilesKMmeters()
                    }}</span>
                  </p>
                  <div
                    class="gauge-wrapper game-pb-cat"
                    :class="
                      getGaugeValue(
                        'game-pb-cat',
                        Math.round(
                          playerPersonalBestAndAverages.games.pb
                            .session_distance,
                        ),
                      )
                    "
                  >
                    <div class="gauge">
                      <p>
                        {{
                          getGaugeValue(
                            "game-pb-cat",
                            Math.round(
                              playerPersonalBestAndAverages.games.pb
                                .session_distance,
                            ),
                            "notCss",
                          )
                        }}
                      </p>
                    </div>
                  </div>

                  <div
                    class="gauge-wrapper game-hsr-cat"
                    :class="
                      getGaugeValue(
                        'game-hsr-cat',
                        Math.round(
                          playerPersonalBestAndAverages.games.pb
                            .session_distance,
                        ),
                      )
                    "
                  >
                    <div class="gauge">
                      <p>
                        {{
                          getGaugeValue(
                            "game-hsr-cat",
                            Math.round(
                              playerPersonalBestAndAverages.games.pb
                                .session_distance,
                            ),
                            "notCss",
                          )
                        }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="metrics-item">
                  <p class="title">Game Last session</p>
                  <p class="value">
                    {{
                      roundedGameAvgDistance(
                        lastGameSessionData.session_distance,
                      )
                    }}
                    <span class="very-large">{{
                      unitLabelMilesKMmeters()
                    }}</span>
                  </p>

                  <div
                    class="gauge-wrapper game-pb-cat"
                    :class="
                      getGaugeValue(
                        'game-pb-cat',
                        Math.round(lastGameSessionData.session_distance),
                      )
                    "
                  >
                    <div class="gauge">
                      <p>
                        {{
                          getGaugeValue(
                            "game-pb-cat",
                            Math.round(lastGameSessionData.session_distance),
                            "notCss",
                          )
                        }}
                      </p>
                    </div>
                  </div>

                  <p class="session-date">
                    Session date:
                    {{ formatDate(lastGameSessionData.session_date) }}
                  </p>
                </div>

                <Bar-game-training-avg-chart
                  class="pb-chart"
                  v-if="playerDailyMins.length > 0"
                  :chartData="
                    lineGameTrainingAvgChartData(
                      playerDailyMins,
                      'Session',
                      'session_distance',
                      'Session Distance',
                      'catapult',
                    )
                  "
                />
              </div>
            </div>

            <div
              class="tab-content"
              v-if="catapultGameTab === 'catapult-game-hsr-tab'"
            >
              <div class="metrics-wrapper">
                <h4>
                  High Speed Running
                  <span class="small-select">
                    <b-form-select class="mb-3" v-model="unitValue">
                      <b-form-select-option value="Meters"
                        >Meters</b-form-select-option
                      >
                      <b-form-select-option value="Miles"
                        >Miles</b-form-select-option
                      >
                      <b-form-select-option value="Km">Km</b-form-select-option>
                    </b-form-select>
                  </span>
                </h4>

                <div class="metrics-item">
                  <p class="title">Game Avg</p>
                  <p class="value">
                    {{
                      roundedGameAvgDistance(
                        playerPersonalBestAndAverages.games
                          .total_absolute_high_speed_distance,
                      )
                    }}
                    <span class="very-large">{{
                      unitLabelMilesKMmeters()
                    }}</span>
                  </p>

                  <div
                    class="gauge-wrapper game-hsr-cat"
                    :class="
                      getGaugeValue(
                        'game-hsr-cat',
                        Math.round(
                          playerPersonalBestAndAverages.games
                            .total_absolute_high_speed_distance,
                        ),
                      )
                    "
                  >
                    <div class="gauge">
                      <p>
                        {{
                          getGaugeValue(
                            "game-hsr-cat",
                            Math.round(
                              playerPersonalBestAndAverages.games
                                .total_absolute_high_speed_distance,
                            ),
                            "notCss",
                          )
                        }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="metrics-item">
                  <p class="title">Game PB</p>
                  <p class="value">
                    {{
                      roundedGameAvgDistance(
                        playerPersonalBestAndAverages.games.pb
                          .total_absolute_high_speed_distance,
                      )
                    }}
                    <span class="very-large">{{
                      unitLabelMilesKMmeters()
                    }}</span>
                  </p>

                  <div
                    class="gauge-wrapper game-hsr-cat"
                    :class="
                      getGaugeValue(
                        'game-hsr-cat',
                        Math.round(
                          playerPersonalBestAndAverages.games.pb
                            .total_absolute_high_speed_distance,
                        ),
                      )
                    "
                  >
                    <div class="gauge">
                      <p>
                        {{
                          getGaugeValue(
                            "game-hsr-cat",
                            Math.round(
                              playerPersonalBestAndAverages.games.pb
                                .total_absolute_high_speed_distance,
                            ),
                            "notCss",
                          )
                        }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="metrics-item">
                  <p class="title">Game Last session</p>
                  <p class="value">
                    {{
                      roundedGameAvgDistance(
                        lastGameSessionData.total_absolute_high_speed_distance,
                      )
                    }}
                    <span class="very-large">{{
                      unitLabelMilesKMmeters()
                    }}</span>
                  </p>
                  <div
                    class="gauge-wrapper game-hsr-cat"
                    :class="
                      getGaugeValue(
                        'game-hsr-cat',
                        Math.round(
                          lastGameSessionData.total_absolute_high_speed_distance,
                        ),
                      )
                    "
                  >
                    <div class="gauge">
                      <p>
                        {{
                          getGaugeValue(
                            "game-hsr-cat",
                            Math.round(
                              lastGameSessionData.total_absolute_high_speed_distance,
                            ),
                            "notCss",
                          )
                        }}
                      </p>
                    </div>
                  </div>

                  <p class="session-date">
                    Session date:
                    {{ formatDate(lastGameSessionData.session_date) }}
                  </p>
                </div>

                <Bar-game-training-avg-chart
                  v-if="playerDailyMins.length > 0"
                  :chartData="
                    lineGameTrainingAvgChartData(
                      playerDailyMins,
                      'Session',
                      'total_absolute_high_speed_distance',
                      'High Speed Running',
                      'catapult',
                    )
                  "
                />
              </div>
            </div>

            <div
              class="tab-content"
              v-if="catapultGameTab === 'catapult-game-accelerations-tab'"
            >
              <div class="metrics-wrapper">
                <h4>
                  Accelerations / Decelerations
                  <span class="small-select">
                    <b-form-select class="mb-3" v-model="unitValue">
                      <b-form-select-option value="Meters"
                        >Meters</b-form-select-option
                      >
                      <b-form-select-option value="Miles"
                        >Miles</b-form-select-option
                      >
                      <b-form-select-option value="Km">Km</b-form-select-option>
                    </b-form-select>
                  </span>
                </h4>

                <div class="metrics-sub-wrapper">
                  <p stlye="width: 100%">Accelerations</p>

                  <div class="metrics-item">
                    <p class="title">Game Avg</p>
                    <p class="value">
                      {{
                        roundedGameAvgDistance(
                          playerPersonalBestAndAverages.games
                            .accelerations_total_efforts,
                        )
                      }}
                      <span class="very-large">{{
                        unitLabelMilesKMmeters()
                      }}</span>
                    </p>

                    <div
                      class="gauge-wrapper game-acc-decel-cat"
                      :class="
                        getGaugeValue(
                          'game-acc-decel-cat',
                          Math.round(
                            playerPersonalBestAndAverages.games
                              .accelerations_total_efforts,
                          ),
                        )
                      "
                    >
                      <div class="gauge">
                        <p>
                          {{
                            getGaugeValue(
                              "game-acc-decel-cat",
                              Math.round(
                                playerPersonalBestAndAverages.games
                                  .accelerations_total_efforts,
                              ),
                              "notCss",
                            )
                          }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Game PB</p>
                    <p class="value">
                      {{
                        roundedGameAvgDistance(
                          playerPersonalBestAndAverages.games.pb
                            .accelerations_total_efforts,
                        )
                      }}
                      <span class="very-large">{{
                        unitLabelMilesKMmeters()
                      }}</span>
                    </p>

                    <div
                      class="gauge-wrapper game-acc-decel-cat"
                      :class="
                        getGaugeValue(
                          'game-acc-decel-cat',
                          Math.round(
                            playerPersonalBestAndAverages.games.pb
                              .accelerations_total_efforts,
                          ),
                        )
                      "
                    >
                      <div class="gauge">
                        <p>
                          {{
                            getGaugeValue(
                              "game-acc-decel-cat",
                              Math.round(
                                playerPersonalBestAndAverages.games.pb
                                  .accelerations_total_efforts,
                              ),
                              "notCss",
                            )
                          }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Game Last session</p>
                    <p class="value">
                      {{
                        roundedGameAvgDistance(
                          lastGameSessionData.accelerations_total_efforts,
                        )
                      }}
                      <span class="very-large">{{
                        unitLabelMilesKMmeters()
                      }}</span>
                    </p>

                    <div
                      class="gauge-wrapper game-acc-decel-cat"
                      :class="
                        getGaugeValue(
                          'game-acc-decel-cat',
                          roundedGameAvgDistance(
                            lastGameSessionData.accelerations_total_efforts,
                          ),
                        )
                      "
                    >
                      <div class="gauge">
                        <p>
                          {{
                            getGaugeValue(
                              "game-acc-decel-cat",
                              roundedGameAvgDistance(
                                lastGameSessionData.accelerations_total_efforts,
                              ),
                              "notCss",
                            )
                          }}
                        </p>
                      </div>
                    </div>
                    <p class="session-date">
                      Session date:
                      {{ formatDate(lastGameSessionData.session_date) }}
                    </p>
                  </div>
                </div>

                <div class="metrics-sub-wrapper">
                  <p stlye="width: 100%">Decelerations</p>

                  <div class="metrics-item">
                    <p class="title">Game Avg</p>
                    <p class="value">
                      {{
                        roundedGameAvgDistance(
                          playerPersonalBestAndAverages.games
                            .decelerations_total_efforts,
                        )
                      }}
                      <span class="very-large">{{
                        unitLabelMilesKMmeters()
                      }}</span>
                    </p>

                    <div
                      class="gauge-wrapper game-acc-decel-cat"
                      :class="
                        getGaugeValue(
                          'game-acc-decel-cat',
                          roundedGameAvgDistance(
                            playerPersonalBestAndAverages.games
                              .decelerations_total_efforts,
                          ),
                        )
                      "
                    >
                      <div class="gauge">
                        <p>
                          {{
                            getGaugeValue(
                              "game-acc-decel-cat",
                              roundedGameAvgDistance(
                                playerPersonalBestAndAverages.games
                                  .decelerations_total_efforts,
                              ),
                              "notCss",
                            )
                          }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Game PB</p>
                    <p class="value">
                      {{
                        roundedGameAvgDistance(
                          playerPersonalBestAndAverages.games.pb
                            .decelerations_total_efforts,
                        )
                      }}
                      <span class="very-large">{{
                        unitLabelMilesKMmeters()
                      }}</span>
                    </p>

                    <div
                      class="gauge-wrapper game-acc-decel-cat"
                      :class="
                        getGaugeValue(
                          'game-acc-decel-cat',
                          roundedGameAvgDistance(
                            playerPersonalBestAndAverages.games.pb
                              .decelerations_total_efforts,
                          ),
                        )
                      "
                    >
                      <div class="gauge">
                        <p>
                          {{
                            getGaugeValue(
                              "game-acc-decel-cat",
                              roundedGameAvgDistance(
                                playerPersonalBestAndAverages.games.pb
                                  .decelerations_total_efforts,
                              ),
                              "notCss",
                            )
                          }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Game Last session</p>
                    <p class="value">
                      {{
                        roundedGameAvgDistance(
                          lastGameSessionData.decelerations_total_efforts,
                        )
                      }}
                      <span class="very-large">{{
                        unitLabelMilesKMmeters()
                      }}</span>
                    </p>

                    <div
                      class="gauge-wrapper game-acc-decel-cat"
                      :class="
                        getGaugeValue(
                          'game-acc-decel-cat',
                          Math.round(
                            lastGameSessionData.decelerations_total_efforts,
                          ),
                        )
                      "
                    >
                      <div class="gauge">
                        <p>
                          {{
                            getGaugeValue(
                              "game-acc-decel-cat",
                              Math.round(
                                lastGameSessionData.decelerations_total_efforts,
                              ),
                              "notCss",
                            )
                          }}
                        </p>
                      </div>
                    </div>
                    <p class="session-date">
                      Session date:
                      {{ formatDate(lastGameSessionData.session_date) }}
                    </p>
                  </div>
                </div>

                <Bar-game-training-avg-chart
                  v-if="playerDailyMins.length > 0"
                  :chartData="
                    lineGameTrainingAvgChartData(
                      playerDailyMins,
                      'Session',
                      'accelerations_total_efforts',
                      'Accelerations',
                      'catapult',
                    )
                  "
                />
              </div>
            </div>

            <div
              class="tab-content"
              v-if="catapultGameTab === 'catapult-game-intensity-tab'"
            >
              <div class="metrics-wrapper">
                <h4>Intensity</h4>

                <div class="metrics-item">
                  <p class="title">Game Avg</p>
                  <p class="value">
                    {{
                      roundedGameAvgDistance(
                        playerPersonalBestAndAverages.games.pb
                          .meterage_per_minute,
                      )
                    }}
                    <span class="very-large">{{
                      unitLabelMilesKMmeters()
                    }}</span>
                  </p>

                  <div
                    class="gauge-wrapper game-intensity-cat"
                    :class="
                      getGaugeValue(
                        'game-intensity-cat',
                        roundedGameAvgDistance(
                          playerPersonalBestAndAverages.games.pb
                            .meterage_per_minute,
                        ),
                      )
                    "
                  >
                    <div class="gauge">
                      <p>
                        {{
                          getGaugeValue(
                            "game-intensity-cat",
                            roundedGameAvgDistance(
                              playerPersonalBestAndAverages.games.pb
                                .meterage_per_minute,
                            ),
                            "notCss",
                          )
                        }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="metrics-item">
                  <p class="title">Game PB</p>
                  <p class="value">
                    {{
                      roundedGameAvgDistance(
                        playerPersonalBestAndAverages.games.meterage_per_minute,
                      )
                    }}
                    <span class="very-large">{{
                      unitLabelMilesKMmeters()
                    }}</span>
                  </p>

                  <div
                    class="gauge-wrapper game-intensity-cat"
                    :class="
                      getGaugeValue(
                        'game-intensity-cat',
                        roundedGameAvgDistance(
                          playerPersonalBestAndAverages.games.pb
                            .meterage_per_minute,
                        ),
                      )
                    "
                  >
                    <div class="gauge">
                      <p>
                        {{
                          getGaugeValue(
                            "game-intensity-cat",
                            roundedGameAvgDistance(
                              playerPersonalBestAndAverages.games.pb
                                .meterage_per_minute,
                            ),
                            "notCss",
                          )
                        }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="metrics-item">
                  <p class="title">Game Last session</p>
                  <p class="value">
                    {{
                      roundedGameAvgDistance(
                        lastGameSessionData.meterage_per_minute,
                      )
                    }}
                    <span class="very-large">{{
                      unitLabelMilesKMmeters()
                    }}</span>
                  </p>

                  <div
                    class="gauge-wrapper game-intensity-cat"
                    :class="
                      getGaugeValue(
                        'game-intensity-cat',
                        roundedGameAvgDistance(
                          lastGameSessionData.meterage_per_minute,
                        ),
                      )
                    "
                  >
                    <div class="gauge">
                      <p>
                        {{
                          getGaugeValue(
                            "game-intensity-cat",
                            roundedGameAvgDistance(
                              lastGameSessionData.meterage_per_minute,
                            ),
                            "notCss",
                          )
                        }}
                      </p>
                    </div>
                  </div>
                  <p class="session-date">
                    Session date:
                    {{ formatDate(lastGameSessionData.session_date) }}
                  </p>
                </div>

                <Bar-game-training-avg-chart
                  v-if="playerDailyMins.length > 0"
                  :chartData="
                    lineGameTrainingAvgChartData(
                      playerDailyMins,
                      'Session',
                      'meterage_per_minute',
                      'Intensity',
                      'catapult',
                    )
                  "
                />
              </div>
            </div>

            <div
              class="tab-content"
              v-if="catapultGameTab === 'catapult-game-perTopSpeed-tab'"
            >
              <div class="metrics-wrapper">
                <h4>% Top Speed</h4>

                <div class="metrics-item">
                  <p class="title">Game Avg</p>
                  <p class="value">
                    {{
                      roundedGameAvgDistance(
                        playerPersonalBestAndAverages.games.max_vel_max,
                      )
                    }}
                    <span class="very-large">%</span>
                  </p>

                  <div
                    class="gauge-wrapper game-top-speed-per-cat"
                    :class="
                      getGaugeValue(
                        'game-top-speed-per-cat',
                        roundedGameAvgDistance(
                          playerPersonalBestAndAverages.games.max_vel_max,
                        ),
                      )
                    "
                  >
                    <div class="gauge">
                      <p>
                        {{
                          getGaugeValue(
                            "game-top-speed-per-cat",
                            roundedGameAvgDistance(
                              playerPersonalBestAndAverages.games.max_vel_max,
                            ),
                            "notCss",
                          )
                        }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="metrics-item">
                  <p class="title">Game PB</p>
                  <p class="value">
                    {{
                      roundedGameAvgDistance(
                        playerPersonalBestAndAverages.games.pb.max_vel_max,
                      )
                    }}
                    <span class="very-large">%</span>
                  </p>

                  <div
                    class="gauge-wrapper game-top-speed-per-cat"
                    :class="
                      getGaugeValue(
                        'game-top-speed-per-cat',
                        roundedGameAvgDistance(
                          playerPersonalBestAndAverages.games.pb.max_vel_max,
                        ),
                      )
                    "
                  >
                    <div class="gauge">
                      <p>
                        {{
                          getGaugeValue(
                            "game-top-speed-per-cat",
                            roundedGameAvgDistance(
                              playerPersonalBestAndAverages.games.pb
                                .max_vel_max,
                            ),
                            "notCss",
                          )
                        }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="metrics-item">
                  <p class="title">Game Last session</p>
                  <p class="value">
                    {{
                      roundedGameAvgDistance(lastGameSessionData.max_vel_max)
                    }}
                    <span class="very-large">%</span>
                  </p>

                  <div
                    class="gauge-wrapper game-top-speed-per-cat"
                    :class="
                      getGaugeValue(
                        'game-top-speed-per-cat',
                        roundedGameAvgDistance(lastGameSessionData.max_vel_max),
                      )
                    "
                  >
                    <div class="gauge">
                      <p>
                        {{
                          getGaugeValue(
                            "game-top-speed-per-cat",
                            roundedGameAvgDistance(
                              lastGameSessionData.max_vel_max,
                            ),
                            "notCss",
                          )
                        }}
                      </p>
                    </div>
                  </div>
                  <p class="session-date">
                    Session date:
                    {{ formatDate(lastGameSessionData.session_date) }}
                  </p>
                </div>

                <Bar-game-training-avg-chart
                  v-if="playerDailyMins.length > 0"
                  :chartData="
                    lineGameTrainingAvgChartData(
                      playerDailyMins,
                      'Session',
                      'max_vel_max',
                      '% Top Speed',
                      'catapult',
                    )
                  "
                />
              </div>
            </div>

            <div
              class="tab-content"
              v-if="catapultGameTab === 'catapult-game-topSpeed-tab'"
            >
              <div class="metrics-wrapper">
                <h4>
                  Top Speed
                  <span class="small-select">
                    <b-form-select class="mb-3" v-model="unitValue">
                      <b-form-select-option value="m/s"
                        >m/s</b-form-select-option
                      >
                      <b-form-select-option value="Mph"
                        >Mph</b-form-select-option
                      >
                    </b-form-select>
                  </span>
                </h4>

                <div class="metrics-item">
                  <p class="title">Game Avg</p>
                  <p class="value">
                    {{
                      roundedGameAvgDistance(
                        playerPersonalBestAndAverages.games.maximum_velocity,
                      )
                    }}
                    <span class="very-large">{{
                      unitLabelMilesKMmeters()
                    }}</span>
                  </p>

                  <div
                    class="gauge-wrapper game-top-speed-cat"
                    :class="
                      getGaugeValue(
                        'game-top-speed-cat',
                        Math.round(
                          playerPersonalBestAndAverages.games.maximum_velocity,
                        ),
                      )
                    "
                  >
                    <div class="gauge">
                      <p>
                        {{
                          getGaugeValue(
                            "game-top-speed-cat",
                            Math.round(
                              playerPersonalBestAndAverages.games
                                .maximum_velocity,
                            ),
                            "notCss",
                          )
                        }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="metrics-item">
                  <p class="title">Game PB</p>
                  <p class="value">
                    {{
                      roundedGameAvgDistance(
                        playerPersonalBestAndAverages.games.pb.maximum_velocity,
                      )
                    }}
                    <span class="very-large">{{
                      unitLabelMilesKMmeters()
                    }}</span>
                  </p>

                  <div
                    class="gauge-wrapper game-top-speed-cat"
                    :class="
                      getGaugeValue(
                        'game-top-speed-cat',
                        Math.round(
                          playerPersonalBestAndAverages.games.pb
                            .maximum_velocity,
                        ),
                      )
                    "
                  >
                    <div class="gauge">
                      <p>
                        {{
                          getGaugeValue(
                            "game-top-speed-cat",
                            Math.round(
                              playerPersonalBestAndAverages.games.pb
                                .maximum_velocity,
                            ),
                            "notCss",
                          )
                        }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="metrics-item">
                  <p class="title">Game Last session</p>
                  <p class="value">
                    {{
                      roundedGameAvgDistance(
                        lastGameSessionData.maximum_velocity,
                      )
                    }}
                    <span class="very-large">{{
                      unitLabelMilesKMmeters()
                    }}</span>
                  </p>

                  <div
                    class="gauge-wrapper game-top-speed-cat"
                    :class="
                      getGaugeValue(
                        'game-top-speed-cat',
                        Math.round(lastGameSessionData.maximum_velocity),
                      )
                    "
                  >
                    <div class="gauge">
                      <p>
                        {{
                          getGaugeValue(
                            "game-top-speed-cat",
                            Math.round(lastGameSessionData.maximum_velocity),
                            "notCss",
                          )
                        }}
                      </p>
                    </div>
                  </div>
                  <p class="session-date">
                    Session date:
                    {{ formatDate(lastGameSessionData.session_date) }}
                  </p>
                </div>
              </div>

              <Bar-game-training-avg-chart
                v-if="playerDailyMins.length > 0"
                :chartData="
                  lineGameTrainingAvgChartData(
                    playerDailyMins,
                    'Session',
                    'maximum_velocity',
                    'Top Speed',
                    'catapult',
                  )
                "
              />
            </div>
          </div>
        </div>
        <div class="empty-state" v-else>
          <img src="./img/graphEmptyState.svg" />
          <p>No GPS data available for this player.</p>
        </div>
      </div>
    </template>
  </GPSModal>
  <!-- End Catapult Game Modal -->

  <GPSModal
    v-if="showPlayerMakerGameGPSModal"
    :showModal="showPlayerMakerGameGPSModal"
    @update:showModal="showPlayerMakerGameGPSModal = $event"
    @update:activeTab="activeGPSTab = $event"
    size="xl"
    :modalTitle="'Seasons GPS PlayerMaker Game Reports'"
    :activeTab="activeGPSTab"
  >
    <template #overview>
      <div class="tab-panel overview-panel">
        <div class="overview-grid">
          <div class="radar-section">
            <RadarPerformanceChart
              :gps-data="lastTrainingPlayMakerSessionData"
              :personal-best="
                currentPersonalBestAndAveragesPlayerMakerData.games &&
                currentPersonalBestAndAveragesPlayerMakerData.games.pb
              "
              :season-average="
                currentPersonalBestAndAveragesPlayerMakerData.games
              "
              :last-session="lastTrainingPlayMakerSessionData"
              :gps-type="'playermaker'"
            />
          </div>
          <div class="metrics-summary">
            <h4>Performance Summary</h4>
            <div class="summary-grid">
              <div class="summary-card distance">
                <div class="card-icon">🏃</div>
                <div class="card-content">
                  <h5>Total Distance</h5>
                  <p class="value">
                    {{ getFormattedPlayerMakerValue("distance", "game") }}
                  </p>
                  <span
                    class="trend"
                    :class="getPlayerMakerTrendClass('distance')"
                  >
                    {{ getPlayerMakerTrendPercentage("distance") }}
                  </span>
                </div>
              </div>
              <div class="summary-card speed">
                <div class="card-icon">⚡</div>
                <div class="card-content">
                  <h5>Top Speed</h5>
                  <p class="value">
                    {{ getFormattedPlayerMakerValue("speed", "game") }}
                  </p>
                  <span
                    class="trend"
                    :class="getPlayerMakerTrendClass('speed')"
                  >
                    {{ getPlayerMakerTrendPercentage("speed") }}
                  </span>
                </div>
              </div>
              <div class="summary-card intensity">
                <div class="card-icon">🔥</div>
                <div class="card-content">
                  <h5>Work Rate</h5>
                  <p class="value">
                    {{ getFormattedPlayerMakerValue("workRate", "game") }}
                  </p>
                  <span
                    class="trend"
                    :class="getPlayerMakerTrendClass('workRate')"
                  >
                    {{ getPlayerMakerTrendPercentage("workRate") }}
                  </span>
                </div>
              </div>
              <div class="summary-card touches">
                <div class="card-icon">⚽</div>
                <div class="card-content">
                  <h5>Total Touches</h5>
                  <p class="value">
                    {{ getFormattedPlayerMakerValue("touches", "game") }}
                  </p>
                  <span
                    class="trend"
                    :class="getPlayerMakerTrendClass('touches')"
                  >
                    {{ getPlayerMakerTrendPercentage("touches") }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #detailed>
      <div class="tab-panel detailed-panel">
        <section
          class="session-metrics"
          v-if="checkPlayerMinsForPlayMakerGameId()"
        >
          <div class="report-charts" v-if="playerPlayMakerGpsData.length > 0">
            <h3>Session effort score and stats</h3>

            <b-form-select
              class="mb-3"
              v-model="metricsGameTab"
              v-if="Object.keys(playerMakerPersonalBestAndAverages).length > 0"
            >
              <b-form-select-option :value="null"
                >Please select an option</b-form-select-option
              >
              <b-form-select-option value="game-distance-tab"
                >Total Distance</b-form-select-option
              >
              <b-form-select-option value="game-phase_duration_min-tab"
                >Session Duration</b-form-select-option
              >
              <b-form-select-option value="game-work_rate-tab"
                >Work Rate</b-form-select-option
              >
              <b-form-select-option value="game-total_touches-tab"
                >Total Touches</b-form-select-option
              >
              <b-form-select-option value="game-left_leg_touches-tab"
                >Left leg Touches</b-form-select-option
              >
              <b-form-select-option value="game-right_leg_touches-tab"
                >Right leg Touches</b-form-select-option
              >
              <b-form-select-option value="game-releases-tab"
                >Total Passes</b-form-select-option
              >
              <b-form-select-option value="game-releases_left-tab"
                >Left Passes</b-form-select-option
              >
              <b-form-select-option value="game-releases_right-tab"
                >Right Passes</b-form-select-option
              >
              <b-form-select-option value="game-top_speed-tab"
                >Top speed</b-form-select-option
              >
            </b-form-select>

            <div
              class="tabs-wrapper"
              v-if="Object.keys(playerMakerPersonalBestAndAverages).length > 0"
            >
              <div
                class="tab-content"
                v-if="metricsGameTab === 'game-phase_duration_min-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>Session Duration</h4>

                  <div class="metrics-item">
                    <p class="title">Game Avg</p>
                    <p class="value">
                      {{
                        Math.round(
                          playerMakerPersonalBestAndAverages.games
                            .phase_duration_min,
                        )
                      }}
                      <span>Mins</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Game PB</p>
                    <p class="value">
                      {{
                        playerMakerPersonalBestAndAverages.games.pb
                          .phase_duration_min
                      }}
                      <span>Mins</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="session-date">
                      Session date:
                      {{
                        formatDate(lastGamePlayMakerSessionData.session_date)
                      }}
                    </p>
                    <p class="title">Game Last session</p>
                    <p class="value">
                      {{ lastGamePlayMakerSessionData.phase_duration_min }}
                      <span>Mins</span>
                    </p>
                  </div>

                  <Bar-game-training-avg-chart
                    class="table-responsive"
                    v-if="playerPlayMakerGpsData.length > 0"
                    :chartData="
                      lineGameTrainingAvgChartData(
                        playerPlayMakerGpsData,
                        'Session',
                        'phase_duration_min',
                        'Session Duration',
                        'playermaker',
                      )
                    "
                  />
                </div>
              </div>

              <div
                class="tab-content"
                v-if="metricsGameTab === 'game-distance-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>Total Distance</h4>

                  <div class="metrics-item">
                    <p class="title">Game Avg</p>
                    <p class="value">
                      {{
                        Math.round(
                          playerMakerPersonalBestAndAverages.games
                            .distance_covered,
                        )
                      }}
                      <span>Meters</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Game PB</p>
                    <p class="value">
                      {{
                        playerMakerPersonalBestAndAverages.games.pb
                          .distance_covered
                      }}
                      <span>Meters</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="session-date">
                      Session date:
                      {{
                        formatDate(
                          lastTrainingPlayMakerSessionData.session_date,
                        )
                      }}
                    </p>
                    <p class="title">Training Last session</p>
                    <p class="value">
                      {{ lastTrainingPlayMakerSessionData.distance_covered }}
                      <span>Meters</span>
                    </p>
                  </div>

                  <Bar-game-training-avg-chart
                    class="pb-chart"
                    v-if="playerPlayMakerGpsData.length > 0"
                    :chartData="
                      lineGameTrainingAvgChartData(
                        playerPlayMakerGpsData,
                        'Session',
                        'distance_covered',
                        'Total Distance',
                        'playermaker',
                      )
                    "
                  />
                </div>
              </div>

              <div
                class="tab-content"
                v-if="metricsGameTab === 'game-work_rate-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>Work Rate</h4>

                  <div class="metrics-item">
                    <p class="title">Game Avg</p>
                    <p class="value">
                      {{
                        Math.round(
                          playerMakerPersonalBestAndAverages.games.work_rate,
                        )
                      }}
                      <span>M/Min</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Game PB</p>
                    <p class="value">
                      {{
                        playerMakerPersonalBestAndAverages.games.pb.work_rate
                      }}
                      <span>M/Min</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="session-date">
                      Session date:
                      {{
                        formatDate(
                          lastTrainingPlayMakerSessionData.session_date,
                        )
                      }}
                    </p>
                    <p class="title">Training Last session</p>
                    <p class="value">
                      {{ lastTrainingPlayMakerSessionData.work_rate }}
                      <span>M/Min</span>
                    </p>
                  </div>

                  <Bar-game-training-avg-chart
                    class="pb-chart"
                    v-if="playerPlayMakerGpsData.length > 0"
                    :chartData="
                      lineGameTrainingAvgChartData(
                        playerPlayMakerGpsData,
                        'Session',
                        'work_rate',
                        'Work Rate',
                        'playermaker',
                      )
                    "
                  />
                </div>
              </div>

              <div
                class="tab-content"
                v-if="metricsGameTab === 'game-total_touches-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>Total Touches</h4>

                  <div class="metrics-item">
                    <p class="title">Game Avg</p>
                    <p class="value">
                      {{
                        Math.round(
                          playerMakerPersonalBestAndAverages.games
                            .total_touches,
                        )
                      }}
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Game PB</p>
                    <p class="value">
                      {{
                        playerMakerPersonalBestAndAverages.games.pb
                          .total_touches
                      }}
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="session-date">
                      Session date:
                      {{
                        formatDate(lastGamePlayMakerSessionData.session_date)
                      }}
                    </p>
                    <p class="title">Game Last session</p>
                    <p class="value">
                      {{ lastGamePlayMakerSessionData.total_touches }}
                    </p>
                  </div>

                  <Bar-game-training-avg-chart
                    class="pb-chart"
                    v-if="playerPlayMakerGpsData.length > 0"
                    :chartData="
                      lineGameTrainingAvgChartData(
                        playerPlayMakerGpsData,
                        'Session',
                        'total_touches',
                        'Total Touches',
                        'playermaker',
                      )
                    "
                  />
                </div>
              </div>

              <div
                class="tab-content"
                v-if="metricsGameTab === 'game-left_leg_touches-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>Left leg Touches</h4>

                  <div class="metrics-item">
                    <p class="title">Game Avg</p>
                    <p class="value">
                      {{
                        Math.round(
                          playerMakerPersonalBestAndAverages.games
                            .left_leg_touches,
                        )
                      }}
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Game PB</p>
                    <p class="value">
                      {{
                        playerMakerPersonalBestAndAverages.games.pb
                          .left_leg_touches
                      }}
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="session-date">
                      Session date:
                      {{
                        formatDate(lastGamePlayMakerSessionData.session_date)
                      }}
                    </p>
                    <p class="title">Game Last session</p>
                    <p class="value">
                      {{ lastGamePlayMakerSessionData.left_leg_touches }}
                    </p>
                  </div>

                  <Bar-game-training-avg-chart
                    class="pb-chart"
                    v-if="playerPlayMakerGpsData.length > 0"
                    :chartData="
                      lineGameTrainingAvgChartData(
                        playerPlayMakerGpsData,
                        'Session',
                        'left_leg_touches',
                        'Left leg Touches',
                        'playermaker',
                      )
                    "
                  />
                </div>
              </div>

              <div
                class="tab-content"
                v-if="metricsGameTab === 'game-right_leg_touches-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>Right leg Touches</h4>

                  <div class="metrics-item">
                    <p class="title">Game Avg</p>
                    <p class="value">
                      {{
                        Math.round(
                          playerMakerPersonalBestAndAverages.games
                            .right_leg_touches,
                        )
                      }}
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Game PB</p>
                    <p class="value">
                      {{
                        playerMakerPersonalBestAndAverages.games.pb
                          .right_leg_touches
                      }}
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="session-date">
                      Session date:
                      {{
                        formatDate(lastGamePlayMakerSessionData.session_date)
                      }}
                    </p>
                    <p class="title">Game Last session</p>
                    <p class="value">
                      {{ lastGamePlayMakerSessionData.right_leg_touches }}
                    </p>
                  </div>

                  <Bar-game-training-avg-chart
                    class="pb-chart"
                    v-if="playerPlayMakerGpsData.length > 0"
                    :chartData="
                      lineGameTrainingAvgChartData(
                        playerPlayMakerGpsData,
                        'Session',
                        'right_leg_touches',
                        'Right leg Touches',
                        'playermaker',
                      )
                    "
                  />
                </div>
              </div>

              <div
                class="tab-content"
                v-if="metricsGameTab === 'game-releases-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>Total Passes</h4>

                  <div class="metrics-item">
                    <p class="title">Game Avg</p>
                    <p class="value">
                      {{
                        Math.round(
                          playerMakerPersonalBestAndAverages.games.releases,
                        )
                      }}
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Training PB</p>
                    <p class="value">
                      {{ playerMakerPersonalBestAndAverages.games.pb.releases }}
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="session-date">
                      Session date:
                      {{
                        formatDate(lastGamePlayMakerSessionData.session_date)
                      }}
                    </p>
                    <p class="title">Game Last session</p>
                    <p class="value">
                      {{ lastGamePlayMakerSessionData.releases }}
                    </p>
                  </div>

                  <Bar-game-training-avg-chart
                    class="pb-chart"
                    v-if="playerPlayMakerGpsData.length > 0"
                    :chartData="
                      lineGameTrainingAvgChartData(
                        playerPlayMakerGpsData,
                        'Session',
                        'releases',
                        'Total Passes',
                        'playermaker',
                      )
                    "
                  />
                </div>
              </div>

              <div
                class="tab-content"
                v-if="metricsGameTab === 'game-releases_left-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>Left Passes</h4>

                  <div class="metrics-item">
                    <p class="title">Game Avg</p>
                    <p class="value">
                      {{
                        Math.round(
                          playerMakerPersonalBestAndAverages.games
                            .releases_left,
                        )
                      }}
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Game PB</p>
                    <p class="value">
                      {{
                        playerMakerPersonalBestAndAverages.training.pb
                          .releases_left
                      }}
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="session-date">
                      Session date:
                      {{
                        formatDate(lastGamePlayMakerSessionData.session_date)
                      }}
                    </p>
                    <p class="title">Game Last session</p>
                    <p class="value">
                      {{ lastGamePlayMakerSessionData.releases_left }}
                    </p>
                  </div>

                  <Bar-game-training-avg-chart
                    class="pb-chart"
                    v-if="playerPlayMakerGpsData.length > 0"
                    :chartData="
                      lineGameTrainingAvgChartData(
                        playerPlayMakerGpsData,
                        'Session',
                        'releases_left',
                        'Left Passes',
                        'playermaker',
                      )
                    "
                  />
                </div>
              </div>

              <div
                class="tab-content"
                v-if="metricsGameTab === 'game-releases_right-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>Right Passes</h4>

                  <div class="metrics-item">
                    <p class="title">Game Avg</p>
                    <p class="value">
                      {{
                        Math.round(
                          playerMakerPersonalBestAndAverages.games
                            .releases_right,
                        )
                      }}
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Game PB</p>
                    <p class="value">
                      {{
                        playerMakerPersonalBestAndAverages.games.pb
                          .releases_right
                      }}
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="session-date">
                      Session date:
                      {{
                        formatDate(lastGamePlayMakerSessionData.session_date)
                      }}
                    </p>
                    <p class="title">Game Last session</p>
                    <p class="value">
                      {{ lastGamePlayMakerSessionData.releases_right }}
                    </p>
                  </div>

                  <Bar-game-training-avg-chart
                    class="pb-chart"
                    v-if="playerPlayMakerGpsData.length > 0"
                    :chartData="
                      lineGameTrainingAvgChartData(
                        playerPlayMakerGpsData,
                        'Session',
                        'releases_right',
                        'Right Passes',
                        'playermaker',
                      )
                    "
                  />
                </div>
              </div>

              <div
                class="tab-content"
                v-if="metricsGameTab === 'game-top_speed-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>Top speed</h4>

                  <div class="metrics-item">
                    <p class="title">Game Avg</p>
                    <p class="value">
                      {{
                        playerMakerPersonalBestAndAverages.games.pb.top_speed
                      }}
                      <span>M/S</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Game PB</p>
                    <p class="value">
                      {{
                        (
                          Math.round(
                            playerMakerPersonalBestAndAverages.games.pb
                              .top_speed * 100,
                          ) / 100
                        ).toFixed(2)
                      }}
                      <span>M/S</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="session-date">
                      Session date:
                      {{
                        formatDate(lastGamePlayMakerSessionData.session_date)
                      }}
                    </p>
                    <p class="title">Game Last session</p>
                    <p class="value">
                      {{
                        (
                          Math.round(
                            lastGamePlayMakerSessionData.top_speed * 100,
                          ) / 100
                        ).toFixed(2)
                      }}
                      <span>M/S</span>
                    </p>
                  </div>

                  <Bar-game-training-avg-chart
                    class="pb-chart"
                    v-if="playerPlayMakerGpsData.length > 0"
                    :chartData="
                      lineGameTrainingAvgChartData(
                        playerPlayMakerGpsData,
                        'Session',
                        'top_speed',
                        'Top speed',
                        'playermaker',
                      )
                    "
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="empty-state" v-else>
            <img src="./img/graphEmptyState.svg" />
            <p>No GPS data available for this player.</p>
          </div>
        </section>
      </div>
    </template>
  </GPSModal>

  <GPSModal
    v-if="showPlayerMakerTrainingGPSModal"
    :showModal="showPlayerMakerTrainingGPSModal"
    @update:showModal="showPlayerMakerTrainingGPSModal = $event"
    @update:activeTab="activeGPSTab = $event"
    size="xl"
    :modalTitle="'Seasons GPS PlayerMaker Training Reports'"
    :activeTab="activeGPSTab"
  >
    <template #overview>
      <div class="tab-panel overview-panel">
        <div class="overview-grid">
          <div class="radar-section">
            <RadarPerformanceChart
              :gps-data="lastTrainingPlayMakerSessionData"
              :personal-best="
                currentPersonalBestAndAveragesPlayerMakerData.training &&
                currentPersonalBestAndAveragesPlayerMakerData.training.pb
              "
              :season-average="
                currentPersonalBestAndAveragesPlayerMakerData.training
              "
              :last-session="lastTrainingPlayMakerSessionData"
              :gps-type="'playermaker'"
            />
          </div>
          <div class="metrics-summary">
            <h4>Performance Summary</h4>
            <div class="summary-grid">
              <div class="summary-card distance">
                <div class="card-icon">🏃</div>
                <div class="card-content">
                  <h5>Total Distance</h5>
                  <p class="value">
                    {{ getFormattedPlayerMakerValue("distance", "training") }}
                  </p>
                  <span
                    class="trend"
                    :class="getPlayerMakerTrendClass('distance')"
                  >
                    {{ getPlayerMakerTrendPercentage("distance") }}
                  </span>
                </div>
              </div>
              <div class="summary-card speed">
                <div class="card-icon">⚡</div>
                <div class="card-content">
                  <h5>Top Speed</h5>
                  <p class="value">
                    {{ getFormattedPlayerMakerValue("speed", "training") }}
                  </p>
                  <span
                    class="trend"
                    :class="getPlayerMakerTrendClass('speed')"
                  >
                    {{ getPlayerMakerTrendPercentage("speed") }}
                  </span>
                </div>
              </div>
              <div class="summary-card intensity">
                <div class="card-icon">🔥</div>
                <div class="card-content">
                  <h5>Work Rate</h5>
                  <p class="value">
                    {{ getFormattedPlayerMakerValue("workRate", "training") }}
                  </p>
                  <span
                    class="trend"
                    :class="getPlayerMakerTrendClass('workRate')"
                  >
                    {{ getPlayerMakerTrendPercentage("workRate") }}
                  </span>
                </div>
              </div>
              <div class="summary-card touches">
                <div class="card-icon">⚽</div>
                <div class="card-content">
                  <h5>Total Touches</h5>
                  <p class="value">
                    {{ getFormattedPlayerMakerValue("touches", "training") }}
                  </p>
                  <span
                    class="trend"
                    :class="getPlayerMakerTrendClass('touches')"
                  >
                    {{ getPlayerMakerTrendPercentage("touches") }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #detailed>
      <div class="tab-panel detailed-panel">
        <section
          class="session-metrics"
          v-if="playerPlayMakerGpsData.length > 0"
        >
          <div class="report-charts">
            <h3>Session effort score and stats</h3>

            <b-form-select class="mb-3" v-model="metricsTrainingTab">
              <b-form-select-option :value="null"
                >Please select an option</b-form-select-option
              >
              <b-form-select-option value="training-phase_duration_min-tab"
                >Session Duration</b-form-select-option
              >
              <b-form-select-option value="training-distance_covered-tab"
                >Total Distance</b-form-select-option
              >
              <b-form-select-option value="training-work_rate-tab"
                >Work Rate</b-form-select-option
              >
              <b-form-select-option value="training-total_touches-tab"
                >Total Touches</b-form-select-option
              >
              <b-form-select-option value="training-left_leg_touches-tab"
                >Left leg Touches</b-form-select-option
              >
              <b-form-select-option value="training-right_leg_touches-tab"
                >Right leg Touches</b-form-select-option
              >
              <b-form-select-option value="training-releases-tab"
                >Total Passes</b-form-select-option
              >
              <b-form-select-option value="training-releases_left-tab"
                >Left Passes</b-form-select-option
              >
              <b-form-select-option value="training-releases_right-tab"
                >Right Passes</b-form-select-option
              >
              <b-form-select-option value="training-top_speed-tab"
                >Top speed</b-form-select-option
              >
            </b-form-select>

            <div
              class="tabs-wrapper"
              v-if="Object.keys(playerMakerPersonalBestAndAverages).length > 0"
            >
              <div
                class="tab-content"
                v-if="metricsTrainingTab === 'training-phase_duration_min-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>Session Duration</h4>

                  <div class="metrics-item">
                    <p class="title">Training Avg</p>
                    <p class="value">
                      {{
                        Math.round(
                          playerMakerPersonalBestAndAverages.training
                            .phase_duration_min,
                        )
                      }}
                      <span>Mins</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Training PB</p>
                    <p class="value">
                      {{
                        playerMakerPersonalBestAndAverages.training.pb
                          .phase_duration_min
                      }}
                      <span>Mins</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="session-date">
                      Session date:
                      {{
                        formatDate(lastGamePlayMakerSessionData.session_date)
                      }}
                    </p>
                    <p class="title">Training Last session</p>
                    <p class="value">
                      {{ lastGamePlayMakerSessionData.phase_duration_min }}
                      <span>Mins</span>
                    </p>
                  </div>
                  <Bar-game-training-avg-chart
                    class="pb-chart"
                    v-if="playerPlayMakerGpsData.length > 0"
                    :chartData="
                      lineGameTrainingAvgChartData(
                        playerPlayMakerGpsData,
                        'training',
                        'phase_duration_min',
                        'Session Duration',
                        'playmaker',
                      )
                    "
                  />
                </div>
              </div>

              <div
                class="tab-content"
                v-if="metricsTrainingTab === 'training-distance_covered-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>Total Distance</h4>

                  <div class="metrics-item">
                    <p class="title">Training Avg</p>
                    <p class="value">
                      {{
                        Math.round(
                          playerMakerPersonalBestAndAverages.training
                            .distance_covered,
                        )
                      }}
                      <span>Meters</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Training PB</p>
                    <p class="value">
                      {{
                        playerMakerPersonalBestAndAverages.training.pb
                          .distance_covered
                      }}
                      <span>Meters</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="session-date">
                      Session date:
                      {{
                        formatDate(lastGamePlayMakerSessionData.session_date)
                      }}
                    </p>
                    <p class="title">Training Last session</p>
                    <p class="value">
                      {{ lastGamePlayMakerSessionData.distance_covered }}
                      <span>Meters</span>
                    </p>
                  </div>
                  <Bar-game-training-avg-chart
                    class="pb-chart"
                    v-if="playerPlayMakerGpsData.length > 0"
                    :chartData="
                      lineGameTrainingAvgChartData(
                        playerPlayMakerGpsData,
                        'training',
                        'distance_covered',
                        'Total Distance',
                        'playmaker',
                      )
                    "
                  />
                </div>
              </div>

              <div
                class="tab-content"
                v-if="metricsTrainingTab === 'training-work_rate-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>Work Rate</h4>

                  <div class="metrics-item">
                    <p class="title">Training Avg</p>
                    <p class="value">
                      {{
                        Math.round(
                          playerMakerPersonalBestAndAverages.training.work_rate,
                        )
                      }}
                      <span>M/Min</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Training PB</p>
                    <p class="value">
                      {{
                        playerMakerPersonalBestAndAverages.training.pb.work_rate
                      }}
                      <span>M/Min</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="session-date">
                      Session date:
                      {{
                        formatDate(lastGamePlayMakerSessionData.session_date)
                      }}
                    </p>
                    <p class="title">Training Last session</p>
                    <p class="value">
                      {{ lastGamePlayMakerSessionData.work_rate }}
                      <span>M/Min</span>
                    </p>
                  </div>
                  <Bar-game-training-avg-chart
                    class="pb-chart"
                    v-if="playerPlayMakerGpsData.length > 0"
                    :chartData="
                      lineGameTrainingAvgChartData(
                        playerPlayMakerGpsData,
                        'training',
                        'work_rate',
                        'Work Rate',
                        'playmaker',
                      )
                    "
                  />
                </div>
              </div>

              <div
                class="tab-content"
                v-if="metricsTrainingTab === 'training-total_touches-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>Total Touches</h4>

                  <div class="metrics-item">
                    <p class="title">Training Avg</p>
                    <p class="value">
                      {{
                        Math.round(
                          playerMakerPersonalBestAndAverages.training
                            .total_touches,
                        )
                      }}
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Training PB</p>
                    <p class="value">
                      {{
                        playerMakerPersonalBestAndAverages.training.pb
                          .total_touches
                      }}
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="session-date">
                      Session date:
                      {{
                        formatDate(lastGamePlayMakerSessionData.session_date)
                      }}
                    </p>
                    <p class="title">Training Last session</p>
                    <p class="value">
                      {{ lastGamePlayMakerSessionData.total_touches }}
                    </p>
                  </div>
                  <Bar-game-training-avg-chart
                    class="pb-chart"
                    v-if="playerPlayMakerGpsData.length > 0"
                    :chartData="
                      lineGameTrainingAvgChartData(
                        playerPlayMakerGpsData,
                        'training',
                        'total_touches',
                        'Total Touches',
                        'playmaker',
                      )
                    "
                  />
                </div>
              </div>

              <div
                class="tab-content"
                v-if="metricsTrainingTab === 'training-left_leg_touches-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>Left leg Touches</h4>

                  <div class="metrics-item">
                    <p class="title">Training Avg</p>
                    <p class="value">
                      {{
                        Math.round(
                          playerMakerPersonalBestAndAverages.training
                            .left_leg_touches,
                        )
                      }}
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Training PB</p>
                    <p class="value">
                      {{
                        playerMakerPersonalBestAndAverages.training.pb
                          .left_leg_touches
                      }}
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="session-date">
                      Session date:
                      {{
                        formatDate(lastGamePlayMakerSessionData.session_date)
                      }}
                    </p>
                    <p class="title">Training Last session</p>
                    <p class="value">
                      {{ lastGamePlayMakerSessionData.left_leg_touches }}
                    </p>
                  </div>
                  <Bar-game-training-avg-chart
                    class="pb-chart"
                    v-if="playerPlayMakerGpsData.length > 0"
                    :chartData="
                      lineGameTrainingAvgChartData(
                        playerPlayMakerGpsData,
                        'training',
                        'left_leg_touches',
                        'Left leg Touches',
                        'playmaker',
                      )
                    "
                  />
                </div>
              </div>

              <div
                class="tab-content"
                v-if="metricsTrainingTab === 'training-right_leg_touches-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>Right leg Touches</h4>

                  <div class="metrics-item">
                    <p class="title">Training Avg</p>
                    <p class="value">
                      {{
                        Math.round(
                          playerMakerPersonalBestAndAverages.training
                            .right_leg_touches,
                        )
                      }}
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Training PB</p>
                    <p class="value">
                      {{
                        playerMakerPersonalBestAndAverages.training.pb
                          .right_leg_touches
                      }}
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="session-date">
                      Session date:
                      {{
                        formatDate(lastGamePlayMakerSessionData.session_date)
                      }}
                    </p>
                    <p class="title">Training Last session</p>
                    <p class="value">
                      {{ lastGamePlayMakerSessionData.right_leg_touches }}
                    </p>
                  </div>
                  <Bar-game-training-avg-chart
                    class="pb-chart"
                    v-if="playerPlayMakerGpsData.length > 0"
                    :chartData="
                      lineGameTrainingAvgChartData(
                        playerPlayMakerGpsData,
                        'training',
                        'right_leg_touches',
                        'Right leg Touches',
                        'playmaker',
                      )
                    "
                  />
                </div>
              </div>

              <div
                class="tab-content"
                v-if="metricsTrainingTab === 'training-releases-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>Total Passes</h4>

                  <div class="metrics-item">
                    <p class="title">Training Avg</p>
                    <p class="value">
                      {{
                        Math.round(
                          playerMakerPersonalBestAndAverages.training.releases,
                        )
                      }}
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Training PB</p>
                    <p class="value">
                      {{
                        playerMakerPersonalBestAndAverages.training.pb.releases
                      }}
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="session-date">
                      Session date:
                      {{
                        formatDate(lastGamePlayMakerSessionData.session_date)
                      }}
                    </p>
                    <p class="title">Training Last session</p>
                    <p class="value">
                      {{ lastGamePlayMakerSessionData.releases }}
                    </p>
                  </div>
                  <Bar-game-training-avg-chart
                    class="pb-chart"
                    v-if="playerPlayMakerGpsData.length > 0"
                    :chartData="
                      lineGameTrainingAvgChartData(
                        playerPlayMakerGpsData,
                        'training',
                        'releases',
                        'Total Passes',
                        'playmaker',
                      )
                    "
                  />
                </div>
              </div>

              <div
                class="tab-content"
                v-if="metricsTrainingTab === 'training-releases_left-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>Left Passes</h4>

                  <div class="metrics-item">
                    <p class="title">Training Avg</p>
                    <p class="value">
                      {{
                        Math.round(
                          playerMakerPersonalBestAndAverages.training
                            .releases_left,
                        )
                      }}
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Training PB</p>
                    <p class="value">
                      {{
                        playerMakerPersonalBestAndAverages.training.pb
                          .releases_left
                      }}
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="session-date">
                      Session date:
                      {{
                        formatDate(lastGamePlayMakerSessionData.session_date)
                      }}
                    </p>
                    <p class="title">Training Last session</p>
                    <p class="value">
                      {{ lastGamePlayMakerSessionData.releases_left }}
                    </p>
                  </div>
                  <Bar-game-training-avg-chart
                    class="pb-chart"
                    v-if="playerPlayMakerGpsData.length > 0"
                    :chartData="
                      lineGameTrainingAvgChartData(
                        playerPlayMakerGpsData,
                        'training',
                        'releases_left',
                        'Left Passes',
                        'playmaker',
                      )
                    "
                  />
                </div>
              </div>

              <div
                class="tab-content"
                v-if="metricsTrainingTab === 'training-releases_right-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>Right Passes</h4>

                  <div class="metrics-item">
                    <p class="title">Training Avg</p>
                    <p class="value">
                      {{
                        Math.round(
                          playerMakerPersonalBestAndAverages.training
                            .releases_right,
                        )
                      }}
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Training PB</p>
                    <p class="value">
                      {{
                        playerMakerPersonalBestAndAverages.training.pb
                          .releases_right
                      }}
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="session-date">
                      Session date:
                      {{
                        formatDate(lastGamePlayMakerSessionData.session_date)
                      }}
                    </p>
                    <p class="title">Training Last session</p>
                    <p class="value">
                      {{ lastGamePlayMakerSessionData.releases_right }}
                    </p>
                  </div>
                  <Bar-game-training-avg-chart
                    class="pb-chart"
                    v-if="playerPlayMakerGpsData.length > 0"
                    :chartData="
                      lineGameTrainingAvgChartData(
                        playerPlayMakerGpsData,
                        'training',
                        'releases_right',
                        'Right Passes',
                        'playmaker',
                      )
                    "
                  />
                </div>
              </div>

              <div
                class="tab-content"
                v-if="metricsTrainingTab === 'training-top_speed-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>Top speed</h4>

                  <div class="metrics-item">
                    <p class="title">Training Avg</p>
                    <p class="value">
                      {{
                        playerMakerPersonalBestAndAverages.training.pb.top_speed
                      }}
                      <span>M/S</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Training PB</p>
                    <p class="value">
                      {{
                        (
                          Math.round(
                            playerMakerPersonalBestAndAverages.training.pb
                              .top_speed * 100,
                          ) / 100
                        ).toFixed(2)
                      }}
                      <span>M/S</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="session-date">
                      Session date:
                      {{
                        formatDate(lastGamePlayMakerSessionData.session_date)
                      }}
                    </p>
                    <p class="title">Training Last session</p>
                    <p class="value">
                      {{
                        (
                          Math.round(
                            lastGamePlayMakerSessionData.top_speed * 100,
                          ) / 100
                        ).toFixed(2)
                      }}
                      <span>M/S</span>
                    </p>
                  </div>
                  <Bar-game-training-avg-chart
                    class="pb-chart"
                    v-if="playerPlayMakerGpsData.length > 0"
                    :chartData="
                      lineGameTrainingAvgChartData(
                        playerPlayMakerGpsData,
                        'training',
                        'top_speed',
                        'Top speed',
                        'playmaker',
                      )
                    "
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <div class="empty-state" v-else>
          <img src="./img/graphEmptyState.svg" />
          <p>No GPS data available for this player.</p>
        </div>
      </div>
    </template>
  </GPSModal>

  <GPSModal
    v-if="showCatapultTrainingGPSModal"
    :showModal="showCatapultTrainingGPSModal"
    @update:showModal="showCatapultTrainingGPSModal = $event"
    @update:activeTab="activeGPSTab = $event"
    size="xl"
    :modalTitle="'Seasons GPS Catapult Training Reports'"
    :activeTab="activeGPSTab"
  >
    <template #overview>
      <div class="tab-panel overview-panel">
        <div class="catapult-tabs">
          <button
            :class="{ active: catapultSeasonTab === 'current' }"
            @click="changeCatapultSeasonTab('current', 'training')"
          >
            This Season
          </button>
          <button
            :class="{ active: catapultSeasonTab === 'last' }"
            @click="changeCatapultSeasonTab('last', 'training')"
          >
            Last Season
          </button>
        </div>
        <div v-if="catapultSeasonTab === 'current'">
          <div class="overview-grid">
            <div class="radar-section">
              <RadarPerformanceChart
                :gps-data="lastTrainingSessionData"
                :personal-best="
                  currentPersonalBestAndAveragesCatapultData.training &&
                  currentPersonalBestAndAveragesCatapultData.training.pb
                "
                :season-average="
                  currentPersonalBestAndAveragesCatapultData.training
                "
                :last-session="lastTrainingSessionData"
                :gps-type="gpsType"
              />
            </div>
            <div class="metrics-summary">
              <h4>Performance Summary</h4>
              <div class="summary-grid">
                <div class="summary-card distance">
                  <div class="card-icon">🏃</div>
                  <div class="card-content">
                    <h5>Total Distance</h5>
                    <p class="value">
                      {{
                        getFormattedValue("distance", "lastTrainingSessionData")
                      }}
                    </p>
                    <span
                      class="trend"
                      :class="
                        getTrendClass('distance', 'lastTrainingSessionData')
                      "
                    >
                      {{
                        getTrendPercentage(
                          "distance",
                          "lastTrainingSessionData",
                        )
                      }}
                    </span>
                  </div>
                </div>
                <div class="summary-card speed">
                  <div class="card-icon">⚡</div>
                  <div class="card-content">
                    <h5>Top Speed</h5>
                    <p class="value">
                      {{
                        getFormattedValue("speed", "lastTrainingSessionData")
                      }}
                    </p>
                    <span
                      class="trend"
                      :class="getTrendClass('speed', 'lastTrainingSessionData')"
                    >
                      {{
                        getTrendPercentage("speed", "lastTrainingSessionData")
                      }}
                    </span>
                  </div>
                </div>
                <div class="summary-card intensity">
                  <div class="card-icon">🔥</div>
                  <div class="card-content">
                    <h5>Intensity</h5>
                    <p class="value">
                      {{
                        getFormattedValue(
                          "intensity",
                          "lastTrainingSessionData",
                        )
                      }}
                    </p>
                    <span
                      class="trend"
                      :class="
                        getTrendClass('intensity', 'lastTrainingSessionData')
                      "
                    >
                      {{
                        getTrendPercentage(
                          "intensity",
                          "lastTrainingSessionData",
                        )
                      }}
                    </span>
                  </div>
                </div>
                <div class="summary-card hsr">
                  <div class="card-icon">💨</div>
                  <div class="card-content">
                    <h5>High Speed Running</h5>
                    <p class="value">
                      {{ getFormattedValue("hsr", "lastTrainingSessionData") }}
                    </p>
                    <span
                      class="trend"
                      :class="getTrendClass('hsr', 'lastTrainingSessionData')"
                    >
                      {{ getTrendPercentage("hsr", "lastTrainingSessionData") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="catapultSeasonTab === 'last'">
          <div class="overview-grid">
            <div class="radar-section">
              <RadarPerformanceChart
                :gps-data="lastSeasonTrainingSessionData"
                :personal-best="
                  lastSeasonPersonalBestAndAveragesCatapultData.training &&
                  lastSeasonPersonalBestAndAveragesCatapultData.training.pb
                "
                :season-average="
                  lastSeasonPersonalBestAndAveragesCatapultData.training
                "
                :last-session="lastSeasonTrainingSessionData"
                :gps-type="gpsType"
              />
            </div>
            <div class="metrics-summary">
              <h4>Performance Summary</h4>
              <div class="summary-grid">
                <div class="summary-card distance">
                  <div class="card-icon">🏃</div>
                  <div class="card-content">
                    <h5>Total Distance</h5>
                    <p class="value">
                      {{
                        getFormattedValue(
                          "distance",
                          "lastSeasonTrainingSessionData",
                        )
                      }}
                    </p>
                    <span
                      class="trend"
                      :class="
                        getTrendClass(
                          'distance',
                          'lastSeasonTrainingSessionData',
                        )
                      "
                    >
                      {{
                        getTrendPercentage(
                          "distance",
                          "lastSeasonTrainingSessionData",
                        )
                      }}
                    </span>
                  </div>
                </div>
                <div class="summary-card speed">
                  <div class="card-icon">⚡</div>
                  <div class="card-content">
                    <h5>Top Speed</h5>
                    <p class="value">
                      {{
                        getFormattedValue(
                          "speed",
                          "lastSeasonTrainingSessionData",
                        )
                      }}
                    </p>
                    <span
                      class="trend"
                      :class="
                        getTrendClass('speed', 'lastSeasonTrainingSessionData')
                      "
                    >
                      {{
                        getTrendPercentage(
                          "speed",
                          "lastSeasonTrainingSessionData",
                        )
                      }}
                    </span>
                  </div>
                </div>
                <div class="summary-card intensity">
                  <div class="card-icon">🔥</div>
                  <div class="card-content">
                    <h5>Intensity</h5>
                    <p class="value">
                      {{
                        getFormattedValue(
                          "intensity",
                          "lastSeasonTrainingSessionData",
                        )
                      }}
                    </p>
                    <span
                      class="trend"
                      :class="
                        getTrendClass(
                          'intensity',
                          'lastSeasonTrainingSessionData',
                        )
                      "
                    >
                      {{
                        getTrendPercentage(
                          "intensity",
                          "lastSeasonTrainingSessionData",
                        )
                      }}
                    </span>
                  </div>
                </div>
                <div class="summary-card hsr">
                  <div class="card-icon">💨</div>
                  <div class="card-content">
                    <h5>High Speed Running</h5>
                    <p class="value">
                      {{
                        getFormattedValue(
                          "hsr",
                          "lastSeasonTrainingSessionData",
                        )
                      }}
                    </p>
                    <span
                      class="trend"
                      :class="
                        getTrendClass('hsr', 'lastSeasonTrainingSessionData')
                      "
                    >
                      {{
                        getTrendPercentage(
                          "hsr",
                          "lastSeasonTrainingSessionData",
                        )
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #detailed>
      <div class="tab-panel detailed-panel">
        <section class="session-metrics" v-if="playerDailyMins !== null">
          <div class="report-charts">
            <h3>Training avg</h3>
            <b-form-select class="mb-3" v-model="metricsTrainingTab">
              <b-form-select-option :value="null"
                >Please select an option</b-form-select-option
              >
              <b-form-select-option value="training-phase_duration_min-tab"
                >Distance</b-form-select-option
              >
              <b-form-select-option value="training-hsr-tab"
                >High Speed Running</b-form-select-option
              >
              <b-form-select-option value="training-accelerations-tab"
                >Accelerations / Decelerations</b-form-select-option
              >
              <b-form-select-option value="training-intensity-tab"
                >Intensity</b-form-select-option
              >
              <b-form-select-option value="training-topSpeed-tab"
                >% Top Speed</b-form-select-option
              >
              <b-form-select-option value="training-topSpeed-tab"
                >Top Speed</b-form-select-option
              >
            </b-form-select>

            <div class="tabs-wrapper">
              <div
                class="tab-content"
                v-if="metricsTrainingTab === 'training-phase_duration_min-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>
                    Total distance
                    <span class="small-select">
                      <b-form-select class="mb-3" v-model="unitValue">
                        <b-form-select-option value="Meters"
                          >Meters</b-form-select-option
                        >
                        <b-form-select-option value="Miles"
                          >Miles</b-form-select-option
                        >
                        <b-form-select-option value="Km"
                          >Km</b-form-select-option
                        >
                      </b-form-select>
                    </span>
                  </h4>

                  <div class="metrics-item">
                    <p class="title">Training Avg</p>
                    <p class="value">
                      {{
                        roundedGameAvgDistance(
                          playerPersonalBestAndAverages.training
                            .session_distance,
                        )
                      }}
                      <span class="very-large">{{
                        unitLabelMilesKMmeters()
                      }}</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Training PB</p>
                    <p class="value">
                      {{
                        roundedGameAvgDistance(
                          playerPersonalBestAndAverages.training.pb
                            .session_distance,
                        )
                      }}
                      <span class="very-large">{{
                        unitLabelMilesKMmeters()
                      }}</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="session-date">
                      Session date:
                      {{ formatDate(lastTrainingSessionData.session_date) }}
                    </p>
                    <p class="title">Training Last session</p>
                    <p class="value">
                      {{
                        roundedGameAvgDistance(
                          lastTrainingSessionData.session_distance,
                        )
                      }}
                      <span class="very-large">{{
                        unitLabelMilesKMmeters()
                      }}</span>
                    </p>
                  </div>

                  <Bar-game-training-avg-chart
                    class="table-responsive"
                    v-if="playerDailyMins.length > 0"
                    :chartData="
                      lineGameTrainingAvgChartData(
                        playerDailyMins,
                        'training',
                        'session_distance',
                        'Session Distance',
                        'catapult',
                      )
                    "
                  />
                </div>
              </div>

              <div
                class="tab-content"
                v-if="metricsTrainingTab === 'training-hsr-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>
                    High Speed Running
                    <span class="small-select">
                      <b-form-select class="mb-3" v-model="unitValue">
                        <b-form-select-option value="Meters"
                          >Meters</b-form-select-option
                        >
                        <b-form-select-option value="Miles"
                          >Miles</b-form-select-option
                        >
                        <b-form-select-option value="Km"
                          >Km</b-form-select-option
                        >
                      </b-form-select>
                    </span>
                  </h4>

                  <div class="metrics-item">
                    <p class="title">Training Avg</p>
                    <p class="value">
                      {{
                        roundedGameAvgDistance(
                          playerPersonalBestAndAverages.training
                            .total_absolute_high_speed_distance,
                        )
                      }}
                      <span class="very-large">{{
                        unitLabelMilesKMmeters()
                      }}</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Training PB</p>
                    <p class="value">
                      {{
                        roundedGameAvgDistance(
                          playerPersonalBestAndAverages.training.pb
                            .total_absolute_high_speed_distance,
                        )
                      }}
                      <span class="very-large">{{
                        unitLabelMilesKMmeters()
                      }}</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="session-date">
                      Session date:
                      {{ formatDate(lastTrainingSessionData.session_date) }}
                    </p>
                    <p class="title">Training PB</p>
                    <p class="value">
                      {{
                        roundedGameAvgDistance(
                          lastTrainingSessionData.total_absolute_high_speed_distance,
                        )
                      }}
                      <span class="very-large">{{
                        unitLabelMilesKMmeters()
                      }}</span>
                    </p>
                  </div>

                  <Bar-game-training-avg-chart
                    v-if="playerDailyMins.length > 0"
                    :chartData="
                      lineGameTrainingAvgChartData(
                        playerDailyMins,
                        'training',
                        'total_absolute_high_speed_distance',
                        'High Speed Running',
                        'catapult',
                      )
                    "
                  />
                </div>
              </div>

              <div
                class="tab-content"
                v-if="metricsTrainingTab === 'training-accelerations-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>
                    Accelerations / Decelerations
                    <span class="small-select">
                      <b-form-select class="mb-3" v-model="unitValue">
                        <b-form-select-option value="Meters"
                          >Meters</b-form-select-option
                        >
                        <b-form-select-option value="Miles"
                          >Miles</b-form-select-option
                        >
                        <b-form-select-option value="Km"
                          >Km</b-form-select-option
                        >
                      </b-form-select>
                    </span>
                  </h4>

                  <div class="metrics-sub-wrapper">
                    <p>Accelerations</p>

                    <div class="metrics-item">
                      <p class="title">Training Avg</p>
                      <p class="value">
                        {{
                          roundedGameAvgDistance(
                            playerPersonalBestAndAverages.training
                              .accelerations_total_efforts,
                          )
                        }}
                        <span class="very-large">{{
                          unitLabelMilesKMmeters()
                        }}</span>
                      </p>
                    </div>

                    <div class="metrics-item">
                      <p class="title">Training PB</p>
                      <p class="value">
                        {{
                          roundedGameAvgDistance(
                            playerPersonalBestAndAverages.training.pb
                              .accelerations_total_efforts,
                          )
                        }}
                        <span class="very-large">{{
                          unitLabelMilesKMmeters()
                        }}</span>
                      </p>
                    </div>

                    <div class="metrics-item">
                      <p class="session-date">
                        Session date:
                        {{ formatDate(lastTrainingSessionData.session_date) }}
                      </p>
                      <p class="title">Training Last session</p>
                      <p class="value">
                        {{
                          roundedGameAvgDistance(
                            lastTrainingSessionData.accelerations_total_efforts,
                          )
                        }}
                        <span class="very-large">{{
                          unitLabelMilesKMmeters()
                        }}</span>
                      </p>
                    </div>
                  </div>

                  <div class="metrics-sub-wrapper">
                    <p>Decelerations</p>

                    <div class="metrics-item">
                      <p class="title">Training Avg</p>
                      <p class="value">
                        {{
                          Math.round(
                            playerPersonalBestAndAverages.training
                              .decelerations_total_efforts,
                          )
                        }}
                      </p>
                    </div>

                    <div class="metrics-item">
                      <p class="title">Training PB</p>
                      <p class="value">
                        {{
                          playerPersonalBestAndAverages.training.pb
                            .decelerations_total_efforts
                        }}
                        <span>Meters</span>
                      </p>
                    </div>

                    <div class="metrics-item">
                      <p class="session-date">
                        Session date:
                        {{ formatDate(lastTrainingSessionData.session_date) }}
                      </p>
                      <p class="title">Training Last session</p>
                      <p class="value">
                        {{
                          lastTrainingSessionData.decelerations_total_efforts
                        }}
                        <span>Meters</span>
                      </p>
                    </div>
                  </div>

                  <Bar-game-training-avg-chart
                    v-if="playerDailyMins.length > 0"
                    :chartData="
                      lineGameTrainingAvgChartData(
                        playerDailyMins,
                        'training',
                        'accelerations_total_efforts',
                        'Accelerations',
                        'catapult',
                      )
                    "
                  />
                </div>
              </div>

              <div
                class="tab-content"
                v-if="metricsTrainingTab === 'training-intensity-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>Intensity</h4>

                  <div class="metrics-item">
                    <p class="title">Training Avg</p>
                    <p class="value">
                      {{
                        Math.round(
                          playerPersonalBestAndAverages.training
                            .meterage_per_minute,
                        )
                      }}
                      <span>M/Min</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Training PB</p>
                    <p class="value">
                      {{
                        playerPersonalBestAndAverages.training.pb
                          .meterage_per_minute
                      }}
                      <span>M/Min</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="session-date">
                      Session date:
                      {{ formatDate(lastTrainingSessionData.session_date) }}
                    </p>
                    <p class="title">Training Last session</p>
                    <p class="value">
                      {{ lastTrainingSessionData.meterage_per_minute }}
                      <span>M/Min</span>
                    </p>
                  </div>
                  <Bar-game-training-avg-chart
                    v-if="playerDailyMins.length > 0"
                    :chartData="
                      lineGameTrainingAvgChartData(
                        playerDailyMins,
                        'training',
                        'meterage_per_minute',
                        'Intensity',
                        'catapult',
                      )
                    "
                  />
                </div>
              </div>

              <div
                class="tab-content"
                v-if="metricsTrainingTab === 'training-perTopSpeed-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>% Top Speed</h4>

                  <div class="metrics-item">
                    <p class="title">Training Avg</p>
                    <p class="value">
                      {{ playerPersonalBestAndAverages.training.max_vel_max }}
                      <span>Meters</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Training PB</p>
                    <p class="value">
                      {{
                        playerPersonalBestAndAverages.training.pb.max_vel_max
                      }}
                      <span>Meters</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="session-date">
                      Session date:
                      {{ formatDate(lastTrainingSessionData.session_date) }}
                    </p>
                    <p class="title">Training Last session</p>
                    <p class="value">
                      {{ lastTrainingSessionData.max_vel_max }}
                      <span>Meters</span>
                    </p>
                  </div>
                  <Bar-game-training-avg-chart
                    v-if="playerDailyMins.length > 0"
                    :chartData="
                      lineGameTrainingAvgChartData(
                        playerDailyMins,
                        'training',
                        'max_vel_max',
                        '% Top Speed',
                        'catapult',
                      )
                    "
                  />
                </div>
              </div>

              <div
                class="tab-content"
                v-if="metricsTrainingTab === 'training-topSpeed-tab'"
              >
                <div class="metrics-wrapper">
                  <h4>Top Speed</h4>

                  <div class="metrics-item">
                    <p class="title">Training Avg</p>
                    <p class="value">
                      {{ playerPersonalBestAndAverages.maximum_velocity }}
                      <span>M/S</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="title">Training PB</p>
                    <p class="value">
                      {{
                        (
                          Math.round(
                            playerPersonalBestAndAverages.training.pb
                              .maximum_velocity * 100,
                          ) / 100
                        ).toFixed(2)
                      }}
                      <span>M/S</span>
                    </p>
                  </div>

                  <div class="metrics-item">
                    <p class="session-date">
                      Session date:
                      {{ formatDate(lastTrainingSessionData.session_date) }}
                    </p>
                    <p class="title">Training Last session</p>
                    <p class="value">
                      {{
                        (
                          Math.round(
                            lastTrainingSessionData.maximum_velocity * 100,
                          ) / 100
                        ).toFixed(2)
                      }}
                      <span>M/S</span>
                    </p>
                  </div>
                </div>
                <Bar-game-training-avg-chart
                  v-if="playerDailyMins.length > 0"
                  :chartData="
                    lineGameTrainingAvgChartData(
                      playerDailyMins,
                      'training',
                      'maximum_velocity',
                      'Top Speed',
                      'catapult',
                    )
                  "
                />
              </div>
            </div>
          </div>
        </section>
        <div class="empty-state" v-else>
          <img src="./img/graphEmptyState.svg" />
          <p>No GPS data available for this player.</p>
        </div>
      </div>
    </template>
  </GPSModal>
</template>

<script>
import moment from "moment";
import BarGameTrainingAvgChart from "../charts/BarGameTrainingAvgChart";
import RadarPerformanceChart from "../charts/RadarPerformanceChart";
import GPSModal from "@/components/GPSModal.vue";
import removeDuplicatesMixin from "@/mixin/removeDuplicates.js";
import { Teams } from "@/services/teams-service.js";
import MetricDisplaySection from "@/components/PlayerPerformanceOverView/MetricDisplaySection.vue";
import { PlayerPhysicalPerformance } from "@/services/player-physical-performance-service.js";
import { mapGetters } from "vuex";
export default {
  name: "playerPerformanceOverview",
  components: {
    BarGameTrainingAvgChart,
    RadarPerformanceChart,
    GPSModal,
    MetricDisplaySection,
  },
  mixins: [removeDuplicatesMixin],
  data() {
    return {
      catapultSeasonTab: "current",
      metricsGameTab: "game-distance-tab",
      metricsTrainingTab: "training-phase_duration_min-tab",
      // Separate tab controls for each GPS type
      catapultGameTab: "catapult-game-distance-tab",
      catapultTrainingTab: "catapult-training-distance-tab",
      playerMakerGameTab: "playermaker-game-distance-tab",
      playerMakerTrainingTab: "playermaker-training-distance-tab",
      fullSeasonCheckBoxData: true,
      season_start_date: null,
      season_end_date: null,
      clubTeams: [],
      unitValue: "Meters",
      showCatapultGameGPSModal: false,
      showPlayerMakerGameGPSModal: false,
      showCatapultTrainingGPSModal: false,
      showPlayerMakerTrainingGPSModal: false,
      checkIfPlayerHasGamesCatapultGPSData: false,
      checkIfPlayerHasTrainingCatapultGPSData: false,
      activeGPSTab: "overview",
      lastSeasonGameSessionData: null,
      lastSeasonTrainingSessionData: null,
      lastSeasonPersonalBestAndAveragesCatapultData: null,
      currentPersonalBestAndAveragesCatapultData: null,
      currentPersonalBestAndAveragesPlayerMakerData: null,
    };
  },
  props: {
    selectedUserData: {
      type: Object,
      default: Object,
    },
    playerPersonalBestAndAverages: {
      type: [Object, Boolean],
      default: () => ({}),
    },
    lastGameSessionData: {
      type: [Object, Boolean],
      default: () => null,
    },
    lastTrainingSessionData: {
      type: [Object, Boolean],
      default: () => null,
    },
    lastGamePlayMakerSessionData: {
      type: [Object, Boolean],
      default: () => null,
    },
    lastTrainingPlayMakerSessionData: {
      type: [Object, Boolean],
      default: () => null,
    },
    playerDailyMins: {
      type: [Array, Boolean],
      default: () => null,
    },
    playerPlayMakerGpsData: {
      type: [Array, Boolean],
      default: () => null,
    },
    playerMakerPersonalBestAndAverages: {
      type: [Object, Boolean],
      default: () => ({}),
    },
    under16: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    getProfile: {
      handler(user) {
        if (user) {
          // Create a copy to avoid Vue 3 Vuex mutation issues
          this.userData = { ...user };
          this.getTeamsByUserId();
        }
      },
      immediate: true,
    },
    metricsGameTab(newTab) {
      if (newTab === "game-topSpeed-tab") {
        this.unitValue = "m/s";
      }
    },
    showCatapultGameGPSModal(newVal) {
      if (newVal) {
        this.activeGPSTab = "overview";
        this.catapultGameTab = "catapult-game-distance-tab";
      }
    },
    activeGPSTab(newVal) {
      if (this.showCatapultGameGPSModal && newVal === "detailed") {
        this.catapultGameTab = "catapult-game-distance-tab";
      }
    },
  },
  computed: {
    ...mapGetters(["getProfile"]),
    gpsType() {
      return this.under16 ? "playermaker" : "catapult";
    },
  },
  async mounted() {
    this.checkIfPlayerHasGamesCatapultGPSData =
      this.checkForPlayerPersonalBestAndAverages("games");
    this.checkIfPlayerHasTrainingCatapultGPSData =
      this.checkForPlayerPersonalBestAndAverages("training");
    this.currentPersonalBestAndAveragesCatapultData =
      this.currentPersonalBestAndAverages(
        "currentPersonalBestAndAveragesCatapultData",
      );
    if (this.playerPlayMakerGpsData.length > 0) {
      this.currentPersonalBestAndAveragesPlayerMakerData =
        this.currentPersonalBestAndAverages(
          "currentPersonalBestAndAveragesPlayerMakerData",
        );
    }
  },
  beforeUnmount() {
    // Only clear local data, do not mutate props
    this.clubTeams = [];
    this.userData = null;
    // Close any open modals to cleanup references
    this.showCatapultGameGPSModal = false;
    this.showPlayerMakerGameGPSModal = false;
    this.showCatapultTrainingGPSModal = false;
    this.showPlayerMakerTrainingGPSModal = false;
    console.log("PlayerPerformanceOverView component cleanup completed");
  },
  methods: {
    currentPlayerMakerPersonalBestAndAverages(dataType) {
      const data = this[dataType];

      if (!data || typeof data !== "object") {
        return {
          games: { pb: {} },
          training: { pb: {} },
        };
      }

      return {
        games: data.games || { pb: {} },
        training: data.training || { pb: {} },
      };
    },
    currentPersonalBestAndAverages(dataType) {
      const data = this[dataType];

      // Ensure we always return an object with expected structure
      if (!data || typeof data !== "object") {
        return {
          games: { pb: {} },
          training: { pb: {} },
        };
      }

      return {
        games: data.games || { pb: {} },
        training: data.training || { pb: {} },
      };
    },
    async getPlayerMinsPerformanceDataForLastGameSessionLastSeason() {
      const data = {
        action: "getPlayerMinsPerformanceDataForLastGameSessionLastSeason",
        player_id: this.selectedUserData.id,
        season_start_date: this.getLastSeason().startDate,
        season_end_date: this.getLastSeason().endDate,
      };

      const response = await PlayerPhysicalPerformance.find(data).catch(
        (error) => {
          console.log(error);
        },
      );

      if (response.status === 200) {
        this.lastSeasonGameSessionData = response.data;
      }
    },
    async getPlayerMinsPerformanceDataForLastTrainingSessionLastSeason() {
      const data = {
        action: "getPlayerMinsPerformanceDataForLastTrainingLastSession",
        player_id: this.selectedUserData.id,
        season_start_date: this.getLastSeason().startDate,
        season_end_date: this.getLastSeason().endDate,
      };

      const response = await PlayerPhysicalPerformance.find(data).catch(
        (error) => {
          console.log(error);
        },
      );

      if (response.status === 200) {
        this.lastSeasonTrainingSessionData = response.data;
      }
    },
    getCurrentSeason() {
      const now = new Date();
      const currentYear = now.getFullYear();
      const isAfterAugust = now.getMonth() >= 7; // August is month 7 (0-indexed)

      return {
        startYear: isAfterAugust ? currentYear : currentYear - 1,
        endYear: isAfterAugust ? currentYear + 1 : currentYear,
        label: isAfterAugust
          ? `${currentYear}/${currentYear + 1}`
          : `${currentYear - 1}/${currentYear}`,
        startDate: `${isAfterAugust ? currentYear : currentYear - 1}-08-01`,
        endDate: `${isAfterAugust ? currentYear + 1 : currentYear}-05-30`,
      };
    },
    getLastSeason() {
      const current = this.getCurrentSeason();
      return {
        startYear: current.startYear - 1,
        endYear: current.endYear - 1,
        label: `${current.startYear - 1}/${current.endYear - 1}`,
        startDate: `${current.startYear - 1}-08-01`,
        endDate: `${current.endYear - 1}-05-30`,
      };
    },
    async changeCatapultSeasonTab(tab, type) {
      if (tab === "last") {
        switch (type) {
          case "game":
            await this.getPlayerMinsPerformanceDataForLastGameSessionLastSeason();
            break;
          case "training":
            await this.getPlayerMinsPerformanceDataForLastTrainingSessionLastSeason();
            break;
          default:
            this.catapultSeasonTab = "last";
        }

        this.lastSeasonPersonalBestAndAveragesCatapultData =
          this.currentPersonalBestAndAverages(
            "lastSeasonPersonalBestAndAveragesCatapultData",
          );
      } else {
      }

      this.catapultSeasonTab = tab;
    },
    checkForPlayerPersonalBestAndAverages(type) {
      let metrics = [
        "accelerations_total_efforts",
        "decelerations_total_efforts",
        "max_vel_max",
        "maximum_velocity",
        "meterage_per_minute",
        "session_distance",
        "total_absolute_high_speed_distance",
      ];

      // Check that all specified metrics in playerPersonalBestAndAverages are non-zero
      if (
        !this.playerPersonalBestAndAverages ||
        typeof this.playerPersonalBestAndAverages !== "object"
      ) {
        return false;
      }
      return metrics.every(
        (key) =>
          Number(this.playerPersonalBestAndAverages[`${type}`][key]) !== 0 &&
          this.playerPersonalBestAndAverages[`${type}`][key] !== undefined &&
          this.playerPersonalBestAndAverages[`${type}`][key] !== null,
      );
    },
    openGameGPSModal(gpsType) {
      if (gpsType === "catapult") {
        this.showCatapultGameGPSModal = true;
      } else {
        this.showPlayerMakerGameGPSModal = true;
      }
    },
    openTrainingGPSModal(gpsType) {
      if (gpsType === "catapult") {
        this.showCatapultTrainingGPSModal = true;
      } else {
        this.showPlayerMakerTrainingGPSModal = true;
      }
    },
    checkPlayerMinsForPlayMakerGameId() {
      let state = false;
      if (
        this.playerPlayMakerGpsData &&
        this.playerPlayMakerGpsData.length > 0
      ) {
        return true;
      }
      return state;
    },
    getGaugeValue(type, value, notCss) {
      let isLow;
      let isMed;
      let isHigh;
      let returnValue;

      switch (type) {
        case "game-avg-cat":
        case "game-pb-cat":
          isLow = value <= 5000;
          isMed = value >= 5000 && value < 10000;
          isHigh = value >= 10000;
          if (isLow === true) {
            returnValue = notCss !== undefined ? "Low" : "low-gauge";
          }
          if (isMed === true) {
            returnValue = notCss !== undefined ? "Avg" : "avg-gauge";
          }
          if (isHigh === true) {
            returnValue = notCss !== undefined ? "High" : "high-gauge";
          }

          return returnValue;

        case "game-hsr-cat":
          isLow = value <= 500;
          isMed = value >= 500 && value < 1000;
          isHigh = value >= 1000;
          if (isLow === true) {
            returnValue = notCss !== undefined ? "Low" : "low-gauge";
          }
          if (isMed === true) {
            returnValue = notCss !== undefined ? "Avg" : "avg-gauge";
          }
          if (isHigh === true) {
            returnValue = notCss !== undefined ? "High" : "high-gauge";
          }

          return returnValue;

        case "game-acc-decel-cat":
          isLow = value <= 50;
          isMed = value >= 50 && value < 100;
          isHigh = value >= 100;
          if (isLow === true) {
            returnValue = notCss !== undefined ? "Low" : "low-gauge";
          }
          if (isMed === true) {
            returnValue = notCss !== undefined ? "Avg" : "avg-gauge";
          }
          if (isHigh === true) {
            returnValue = notCss !== undefined ? "High" : "high-gauge";
          }

          return returnValue;

        case "game-intensity-cat":
          isLow = value <= 50;
          isMed = value >= 50 && value < 100;
          isHigh = value >= 100;
          if (isLow === true) {
            returnValue = notCss !== undefined ? "Low" : "low-gauge";
          }
          if (isMed === true) {
            returnValue = notCss !== undefined ? "Avg" : "avg-gauge";
          }
          if (isHigh === true) {
            returnValue = notCss !== undefined ? "High" : "high-gauge";
          }

          return returnValue;

        case "game-top-speed-per-cat":
          isLow = value <= 50;
          isMed = value >= 50 && value < 70;
          isHigh = value >= 70;
          if (isLow === true) {
            returnValue = notCss !== undefined ? "Low" : "low-gauge";
          }
          if (isMed === true) {
            returnValue = notCss !== undefined ? "Avg" : "avg-gauge";
          }
          if (isHigh === true) {
            returnValue = notCss !== undefined ? "High" : "high-gauge";
          }

          return returnValue;

        case "game-top-speed-cat":
          isLow = value <= 5;
          isMed = value >= 5 && value < 8;
          isHigh = value >= 8;
          if (isLow === true) {
            returnValue = notCss !== undefined ? "Low" : "low-gauge";
          }
          if (isMed === true) {
            returnValue = notCss !== undefined ? "Avg" : "avg-gauge";
          }
          if (isHigh === true) {
            returnValue = notCss !== undefined ? "High" : "high-gauge";
          }

          return returnValue;

        default:
          return null;
      }
    },
    metersToKilometers(meters) {
      return meters / 1000;
    },
    metersToMiles(meters) {
      const MILES_PER_METER = 0.000621371;
      return meters * MILES_PER_METER;
    },
    convertMpsToMph(mps) {
      const MPH_PER_MPS = 2.23694;
      return mps * MPH_PER_MPS;
    },
    roundedGameAvgDistance(value) {
      switch (this.unitValue) {
        case "Meters":
          return Math.round(value);
        case "Miles":
          return this.metersToMiles(value).toFixed(2);
        case "Km":
          return this.metersToKilometers(value).toFixed(2);
        case "Mph":
          return this.convertMpsToMph(value).toFixed(2);
        case "m/s":
          return value.toFixed(2);
        default:
          return "";
      }
    },
    unitLabelMilesKMmeters() {
      switch (this.unitValue) {
        case "Meters":
          return "Meters";
        case "Miles":
          return "Miles";
        case "Km":
          return "Km";
        case "Mph":
          return "Mph";
        case "m/s":
          return "m/s";
        default:
          return "";
      }
    },
    dateRangeSelected() {
      (this.formatMatchDate(this.dateRange.startDate),
        this.formatMatchDate(this.dateRange.endDate));
    },
    async getTeamsByUserId() {
      const data = {
        action: "getTeamsDataById",
        userId: this.userData.id,
      };

      if (
        this.userData.userType === "Admin" ||
        this.userData.userType === "Coach"
      ) {
        data.clubId = this.userData.clubId;
      }
      const responce = await Teams.find(data).catch((error) => {
        console.log(error);
      });

      this.clubTeams = this.removeDuplicates(responce.data, "id");
      this.season_start_date = this.clubTeams[0].season_start_date;
      this.season_end_date = this.clubTeams[0].season_end_date;
    },
    getTeamName(teamId) {
      if (teamId === "") {
        return teamId;
      }
      var selectedTeam = this.clubTeams.find(function (team) {
        return team.id == teamId;
      });

      return selectedTeam !== undefined ? selectedTeam.teamName : "";
    },
    mapSessionData(data, typeOfData, typeOfChartData, nameOfData, typeOfGPS) {
      // Add data size limit to prevent memory overflow
      if (!data || !Array.isArray(data)) {
        console.warn("Invalid data passed to mapSessionData");
        return {
          label: nameOfData,
          backgroundColor: [],
          borderWidth: 2,
          borderColor: "rgba(0,0,0,0.1)",
          barThickness: 30,
          maxBarThickness: 30,
          data: [],
        };
      }

      if (data.length > 1000) {
        console.warn(
          `Large dataset detected (${data.length} records), limiting to 1000 records`,
        );
        data = data.slice(-1000); // Keep last 1000 records
      }

      const dataArray = [];
      const backgroundColors = [];
      let chartThresholds = {};

      const backgroundColorMap = {
        3: "#ec1111", // Very High
        2: "#DC7C24", // High
        1: "#FFC107", // Moderate
        0: "#4CAF50", // Low
      };

      if (typeOfGPS !== "catapult") {
        chartThresholds = {
          session_distance: {
            veryHigh: 10000,
            high: 5000,
            moderate: 2500,
            low: 0,
          },
          phase_duration_min: {
            veryHigh: 200,
            high: 100,
            moderate: 50,
            low: 0,
          },
          distance_covered: {
            veryHigh: 10000,
            high: 5000,
            moderate: 2500,
            low: 0,
          },
          work_rate: {
            veryHigh: 100,
            high: 50,
            moderate: 25,
            low: 0,
          },
          total_touches: {
            veryHigh: 800,
            high: 400,
            moderate: 150,
            low: 0,
          },
          left_leg_touches: {
            veryHigh: 300,
            high: 150,
            moderate: 50,
            low: 0,
          },
          right_leg_touches: {
            veryHigh: 300,
            high: 150,
            moderate: 50,
            low: 0,
          },
          releases: {
            veryHigh: 250,
            high: 125,
            moderate: 75,
            low: 0,
          },
          releases_right: {
            veryHigh: 100,
            high: 50,
            moderate: 25,
            low: 0,
          },
          releases_left: {
            veryHigh: 100,
            high: 50,
            moderate: 25,
            low: 0,
          },
          top_speed: {
            veryHigh: 10,
            high: 5,
            moderate: 2,
            low: 0,
          },
        };
      } else {
        chartThresholds = {
          session_distance: {
            veryHigh: 10000,
            high: 5000,
            moderate: 2500,
            low: 0,
          },
          total_absolute_high_speed_distance: {
            veryHigh: 1000,
            high: 500,
            moderate: 250,
            low: 0,
          },
          accelerations_total_efforts: {
            veryHigh: 100,
            high: 50,
            moderate: 25,
            low: 0,
          },
          decelerations_total_efforts: {
            veryHigh: 100,
            high: 50,
            moderate: 25,
            low: 0,
          },
          meterage_per_minute: {
            veryHigh: 100,
            high: 50,
            moderate: 25,
            low: 0,
          },
          max_vel_max: { veryHigh: 100, high: 50, moderate: 25, low: 0 },
          maximum_velocity: { veryHigh: 10, high: 5, moderate: 2, low: 0 },
          // Add more chart types here if needed
        };
      }

      const getColorForValue = (value, thresholds) => {
        if (value >= thresholds.veryHigh) return backgroundColorMap[3];
        if (value >= thresholds.high) return backgroundColorMap[2];
        if (value >= thresholds.moderate) return backgroundColorMap[1];
        return backgroundColorMap[0];
      };

      data.forEach((chartData) => {
        const value = chartData[typeOfChartData];
        const thresholds = chartThresholds[typeOfChartData];

        if (typeOfData === "Session" && value !== 0) {
          if (
            chartData.session_type === "Session" &&
            chartData.gameType !== "Training"
          ) {
            backgroundColors.push(getColorForValue(value, thresholds));
            dataArray.push(value);
          }

          if (typeOfGPS === "playermaker") {
            if (
              chartData.session_type === "Game" ||
              chartData.session_type === "League game" ||
              chartData.session_type === "Friendly" ||
              chartData.session_type === "Cup game"
            ) {
              backgroundColors.push(getColorForValue(value, thresholds));
              dataArray.push(value);
            }
          }
        }

        if (typeOfData === "training" && value !== 0) {
          if (typeOfGPS === "playermaker") {
            if (chartData.session_type === "Training") {
              backgroundColors.push(getColorForValue(value, thresholds));
              dataArray.push(value);
            }
          }

          if (
            chartData.session_type === "Session" &&
            chartData.gameType === "Training"
          ) {
            backgroundColors.push(getColorForValue(value, thresholds));
            dataArray.push(value);
          }

          if (
            chartData.session_type === "Training" &&
            chartData.gameType === "Training"
          ) {
            backgroundColors.push(getColorForValue(value, thresholds));
            dataArray.push(value);
          }
        }
      });

      return {
        label: nameOfData,
        backgroundColor: backgroundColors,
        borderWidth: 2,
        borderColor: "rgba(0,0,0,0.1)",
        barThickness: 30,
        maxBarThickness: 30,
        data: dataArray,
      };
    },
    mapSessionDatesToLabels(data, typeOfData, typeOfGPS, typeOfChartData) {
      // Input validation
      if (!data || !Array.isArray(data)) {
        return [];
      }

      const datesArray = [];

      data.forEach((chartData) => {
        // Skip if the main typeOfChartData value is 0
        if (chartData[typeOfChartData] === 0) {
          console.log("Skipping due to zero value for", typeOfChartData);
          return; // Skip this iteration
        }

        // For accelerations, also check decelerations if it's the special case
        if (typeOfChartData === "accelerations_total_efforts") {
          if (chartData["decelerations_total_efforts"] === 0) {
            return; // Skip this iteration
          }
        }

        // Your existing filtering logic continues here...
        if (typeOfData === "Session") {
          if (
            chartData.session_type === "Session" &&
            chartData.gameType !== "Training"
          ) {
            datesArray.push(chartData.session_date);
          }

          if (typeOfGPS === "playermaker") {
            if (
              chartData.session_type === "Game" ||
              chartData.session_type === "League game" ||
              chartData.session_type === "Friendly" ||
              chartData.session_type === "Cup game"
            ) {
              datesArray.push(chartData.session_date);
            }
          }
        }

        if (typeOfData === "training") {
          if (
            chartData.session_type === "Session" &&
            chartData.gameType === "Training"
          ) {
            datesArray.push(chartData.session_date);
          }

          if (
            chartData.session_type === "Training" &&
            chartData.gameType === "Training"
          ) {
            datesArray.push(chartData.session_date);
          }

          if (typeOfGPS === "playermaker") {
            if (chartData.session_type === "Training") {
              datesArray.push(chartData.session_date);
            }
          }
        }
      });

      return datesArray;
    },
    playermakerLineGameTrainingAvgChartData(
      data,
      typeOfData,
      typeOfChartData,
      nameOfData,
      typeOfGPS,
    ) {
      return {
        labels: this.mapSessionDatesToLabels(
          data,
          typeOfData,
          typeOfGPS,
          typeOfChartData,
        ),
        datasets: [
          this.mapSessionData(
            data,
            typeOfData,
            typeOfChartData,
            nameOfData,
            typeOfGPS,
            typeOfChartData,
          ),
        ],
      };
    },
    catapultLineGameTrainingAvgChartData(
      data,
      typeOfData,
      typeOfChartData,
      nameOfData,
      typeOfGPS,
    ) {
      if (
        typeOfChartData === "accelerations_total_efforts" ||
        typeOfChartData === "decelerations_total_efforts"
      ) {
        return {
          labels: this.mapSessionDatesToLabels(
            data,
            typeOfData,
            typeOfGPS,
            typeOfChartData,
          ),
          datasets: [
            this.mapSessionData(
              data,
              typeOfData,
              "decelerations_total_efforts",
              "Decelerations",
              typeOfGPS,
            ),
            this.mapSessionData(
              data,
              typeOfData,
              "accelerations_total_efforts",
              "Accelerations",
              typeOfGPS,
            ),
          ],
        };
      } else {
        return {
          labels: this.mapSessionDatesToLabels(
            data,
            typeOfData,
            typeOfGPS,
            typeOfChartData,
          ),
          datasets: [
            this.mapSessionData(
              data,
              typeOfData,
              typeOfChartData,
              nameOfData,
              typeOfGPS,
            ),
          ],
        };
      }
    },
    formatDate(date) {
      if (date === null) {
        return "No Date";
      }
      return moment(date).format("MMMM Do YYYY");
    },
    formatMatchDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    lineGameTrainingAvgChartData(
      data,
      typeOfData,
      typeOfChartData,
      nameOfData,
      typeOfGPS,
    ) {
      return typeOfGPS === "catapult"
        ? this.catapultLineGameTrainingAvgChartData(
            data,
            typeOfData,
            typeOfChartData,
            nameOfData,
            typeOfGPS,
          )
        : this.playermakerLineGameTrainingAvgChartData(
            data,
            typeOfData,
            typeOfChartData,
            nameOfData,
            typeOfGPS,
          );
    },
    currentPlayingseasonStartDate() {
      return localStorage.getItem("currentPlayingseasonStartDate");
    },
    currentPlayingseasonEndDate() {
      return localStorage.getItem("currentPlayingseasonEndDate");
    },
    getFormattedValue(metric, data) {
      let dataType = this[data];
      if (!dataType) return "0";

      const formatValue = (value, unit = "") => {
        if (value === null || value === undefined) return "0" + unit;
        return Math.round(value).toLocaleString() + unit;
      };

      switch (metric) {
        case "distance":
          return this.roundedGameAvgDistance(dataType.session_distance || 0);
        case "speed":
          return this.roundedGameAvgDistance(dataType.maximum_velocity || 0);
        case "intensity":
          return formatValue(dataType.meterage_per_minute || 0, " m/min");
        case "hsr":
          return this.roundedGameAvgDistance(
            dataType.total_absolute_high_speed_distance || 0,
          );
        default:
          return "0";
      }
    },
    getTrendClass(metric, dataType) {
      const percentage = this.getTrendPercentageRaw(metric, dataType);
      if (percentage > 5) return "trend-up";
      if (percentage < -5) return "trend-down";
      return "trend-neutral";
    },
    getTrendPercentage(metric, dataType) {
      const percentage = this.getTrendPercentageRaw(metric, dataType);
      const direction = percentage > 0 ? "↗" : percentage < 0 ? "↘" : "→";
      return `${direction} ${Math.abs(percentage).toFixed(1)}%`;
    },
    getTrendPercentageRaw(metric, dataType) {
      if (!this[dataType]) {
        return 0;
      }

      const current = this.getCurrentMetricValue(metric, dataType);
      const average = this.getAverageMetricValue(metric, dataType);

      if (!current || !average || average === 0) return 0;

      return ((current - average) / average) * 100;
    },
    getCurrentMetricValue(metric, dataType) {
      if (!this[dataType]) return 0;

      switch (metric) {
        case "distance":
          return this[dataType].session_distance || 0;
        case "speed":
          return this[dataType].maximum_velocity || 0;
        case "intensity":
          return this[dataType].meterage_per_minute || 0;
        case "hsr":
          return this[dataType].total_absolute_high_speed_distance || 0;
        default:
          return 0;
      }
    },
    getAverageMetricValue(metric, dataType) {
      if (!this[dataType].games) return 0;

      switch (metric) {
        case "distance":
          return this[dataType].games.session_distance || 0;
        case "speed":
          return this[dataType].games.maximum_velocity || 0;
        case "intensity":
          return this[dataType].games.meterage_per_minute || 0;
        case "hsr":
          return this[dataType].games.total_absolute_high_speed_distance || 0;
        default:
          return 0;
      }
    },
    getFormattedPlayerMakerValue(metric, type) {
      let dataType =
        type === "training"
          ? this.lastTrainingPlayMakerSessionData
          : this.lastGamePlayMakerSessionData;

      if (!dataType) return "0";

      const formatValue = (value, unit = "") => {
        if (value === null || value === undefined) return "0" + unit;
        return Math.round(value).toLocaleString() + unit;
      };

      switch (metric) {
        case "distance":
          return formatValue(dataType.distance_covered || 0) + " m";
        case "speed":
          return (dataType.top_speed || 0).toFixed(2) + " m/s";
        case "workRate":
          return formatValue(dataType.work_rate || 0) + " m/min";
        case "touches":
          return formatValue(dataType.total_touches || 0);
        default:
          return "0";
      }
    },

    getPlayerMakerTrendClass(metric) {
      const percentage = this.getPlayerMakerTrendPercentageRaw(metric);
      if (percentage > 5) return "trend-up";
      if (percentage < -5) return "trend-down";
      return "trend-neutral";
    },

    getPlayerMakerTrendPercentage(metric) {
      const percentage = this.getPlayerMakerTrendPercentageRaw(metric);
      const direction = percentage > 0 ? "↗" : percentage < 0 ? "↘" : "→";
      return `${direction} ${Math.abs(percentage).toFixed(1)}%`;
    },

    getPlayerMakerTrendPercentageRaw(metric) {
      if (
        !this.lastTrainingPlayMakerSessionData ||
        !this.currentPlayerMakerPersonalBestAndAverages().training
      ) {
        return 0;
      }

      const current = this.getCurrentPlayerMakerMetricValue(metric);
      const average = this.getAveragePlayerMakerMetricValue(metric);

      if (!current || !average || average === 0) return 0;

      return ((current - average) / average) * 100;
    },

    getCurrentPlayerMakerMetricValue(metric) {
      if (!this.lastTrainingPlayMakerSessionData) return 0;

      switch (metric) {
        case "distance":
          return this.lastTrainingPlayMakerSessionData.distance_covered || 0;
        case "speed":
          return this.lastTrainingPlayMakerSessionData.top_speed || 0;
        case "workRate":
          return this.lastTrainingPlayMakerSessionData.work_rate || 0;
        case "touches":
          return this.lastTrainingPlayMakerSessionData.total_touches || 0;
        default:
          return 0;
      }
    },

    getAveragePlayerMakerMetricValue(metric) {
      if (!this.currentPlayerMakerPersonalBestAndAverages().training) return 0;

      switch (metric) {
        case "distance":
          return (
            this.currentPlayerMakerPersonalBestAndAverages().training
              .distance_covered || 0
          );
        case "speed":
          return (
            this.currentPlayerMakerPersonalBestAndAverages().training
              .top_speed || 0
          );
        case "workRate":
          return (
            this.currentPlayerMakerPersonalBestAndAverages().training
              .work_rate || 0
          );
        case "touches":
          return (
            this.currentPlayerMakerPersonalBestAndAverages().training
              .total_touches || 0
          );
        default:
          return 0;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.chart-box {
  min-width: 38rem;
}

.gauge-wrapper {
  --deg: calc(var(--percent) * 1.8deg);
  --thickness: 0.7rem;
  height: 100px;
  display: grid;
  place-items: center;
  position: absolute;
  top: 2rem;
  right: 1rem;

  .gauge {
    width: 100px;
    aspect-ratio: 1;
    background-image:
      radial-gradient(
        closest-side,
        #fff 0%,
        #fff calc(100% - var(--thickness)),
        transparent calc(100% - var(--thickness))
      ),
      conic-gradient(
        from -90deg,
        limegreen 0deg var(--deg),
        transparent var(--deg) 180deg
      ),
      conic-gradient(from -90deg, lightgray 0deg 180deg, transparent 180deg);
    border-radius: 100%;
    display: grid;
    place-items: center;

    p {
      line-height: 1rem;
    }
  }
}

.low-gauge {
  --percent: 30;
}

.avg-gauge {
  --percent: 50;

  .gauge {
    background-image:
      radial-gradient(
        closest-side,
        #fff 0%,
        #fff calc(100% - var(--thickness)),
        transparent calc(100% - var(--thickness))
      ),
      conic-gradient(
        from -90deg,
        #ffc106 0deg var(--deg),
        transparent var(--deg) 180deg
      ),
      conic-gradient(from -90deg, lightgray 0deg 180deg, transparent 180deg);
  }
}

.high-gauge {
  --percent: 100;

  .gauge {
    background-image:
      radial-gradient(
        closest-side,
        #fff 0%,
        #fff calc(100% - var(--thickness)),
        transparent calc(100% - var(--thickness))
      ),
      conic-gradient(
        from -90deg,
        #ff0606 0deg var(--deg),
        transparent var(--deg) 180deg
      ),
      conic-gradient(from -90deg, lightgray 0deg 180deg, transparent 180deg);
  }
}

.search-filter {
  padding: 1rem 0;
}

section.session-metrics {
  .report-charts {
    width: 100%;
  }
}

.player-individual-reports {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  margin-bottom: 2rem;
  width: 100%;

  .view-all-reports {
    &:hover,
    &:focus {
      background: #47a9f9;
      color: white;
      text-decoration: none;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  }
}

.all-training-reports {
  display: flex !important;
  visibility: visible !important;
}

.metrics-wrapper {
  padding: 2rem 0;
  width: 100%;

  .metrics-sub-wrapper {
    width: 100%;
    display: block;

    & > p {
      width: 100%;
    }
  }

  h4 {
    text-transform: uppercase;
    width: 100%;
  }

  .metrics-item {
    border-bottom: 1px dashed #a9b3bc;
    margin-bottom: 1rem;
    position: relative;
    min-width: 18rem;

    .session-date {
      font-size: 0.8rem;
      margin: 0;
      position: relative;
    }

    .title {
      font-size: 0.8rem;
      text-transform: uppercase;
      margin: 0;
    }

    .value {
      font-size: 2.5rem;
      font-weight: bold;
      margin: 0;

      .value-large {
        font-size: 2.5rem;
        font-weight: bold;
        margin: 0;
      }

      span {
        font-size: 0.8rem;
        font-weight: normal;
        margin: 0;
      }
    }
  }
}

@media screen and (min-width: 1024px) {
  h4,
  .h4 {
    font-size: 1.2rem;
  }

  .chart-box {
    min-width: 100%;
  }

  section.session-metrics {
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
  }

  .metrics-wrapper {
    padding: 2rem 0;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;

    .metrics-sub-wrapper {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      gap: 2rem;
    }

    .metrics-item {
      border: 1px dashed #a9b3bc;
      margin-bottom: 1rem;
      padding: 1rem;
      border-radius: 4px;
      width: 27%;
    }
  }
}

@media screen and (min-width: 2399px) {
  .metrics-wrapper {
    .metrics-sub-wrapper {
      & > p {
        width: auto;
      }
    }
  }
}

/* GPS Modal Specific Styles */
.gps-tabs-container {
  margin-bottom: 2rem;
  width: 100%;

  .gps-tab-nav {
    display: flex;
    gap: 1rem;
    border-bottom: 2px solid #e9ecef;

    .tab-btn {
      background: none;
      border: none;
      padding: 1rem 2rem;
      font-size: 1rem;
      font-weight: 500;
      color: #6c757d;
      cursor: pointer;
      transition: all 0.3s ease;
      border-bottom: 3px solid transparent;

      &:hover {
        color: #47a9f9;
        background-color: rgba(71, 169, 249, 0.1);
      }

      &.active {
        color: #47a9f9;
        border-bottom-color: #47a9f9;
        background-color: rgba(71, 169, 249, 0.1);
      }
    }
  }
}

.gps-tab-content {
  width: 100%;
}

.overview-panel {
  .overview-grid {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 2rem;

    .radar-section {
      background: white;
      border-radius: 8px;
      padding: 1.5rem;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      flex: 2;
    }

    .metrics-summary {
      flex: 1;

      h4 {
        margin-bottom: 1.5rem;
        color: #333;
        font-weight: 600;
      }

      .summary-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 1rem;

        @media (max-width: 576px) {
          grid-template-columns: 1fr;
        }
      }

      .summary-card {
        background: white;
        border-radius: 8px;
        padding: 1.5rem;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        border-left: 4px solid #47a9f9;
        transition: transform 0.2s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        &.distance {
          border-left-color: #28a745;
        }

        &.speed {
          border-left-color: #ffc107;
        }

        &.intensity {
          border-left-color: #dc3545;
        }

        &.hsr {
          border-left-color: #17a2b8;
        }

        &.touches {
          border-left-color: #6610f2;
        }

        .card-icon {
          font-size: 2rem;
          margin-bottom: 0.5rem;
        }

        .card-content {
          h5 {
            margin: 0 0 0.5rem 0;
            font-size: 0.9rem;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            color: #6c757d;
            font-weight: 600;
          }

          .value {
            font-size: 2rem;
            font-weight: bold;
            margin: 0 0 0.5rem 0;
            color: #333;
          }

          .trend {
            font-size: 0.9rem;
            font-weight: 500;
            padding: 0.25rem 0.5rem;
            border-radius: 4px;

            &.trend-up {
              background-color: rgba(40, 167, 69, 0.1);
              color: #28a745;
            }

            &.trend-down {
              background-color: rgba(220, 53, 69, 0.1);
              color: #dc3545;
            }

            &.trend-neutral {
              background-color: rgba(108, 117, 125, 0.1);
              color: #6c757d;
            }
          }
        }
      }
    }

    @media (max-width: 768px) {
      flex-direction: column;
    }
  }
}

.tab-panel {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
